// src/pages/FormularioCliente/FormSteps.js
import { useState } from "react";
import styles from "../../App.module.css";
import InputField from "../../components/InputField";

export function useFormState() {
  const initialState = {
    nome: "",
    sobrenome: "",
    cidadeNascimento: "",
    sexo: "",
    estadoNascimento: "",
    dataNascimento: "",
    cpf: "",
    estadoCivil: "",
    alteracaoNome: "",
    detalhesAlteracaoNome: "",
    detalhesAlteracaoSobreNome: "",
    possuiOutraNacionalidade: "",

    viagemEspecifica: "",
    nacionalidade: "",
    consulado: "",
    dataChegada: "",
    duracaoViagem: "",
    cidadePretendida: "",
    estadoPretendido: "",
    zipcode: "",
    hospedagem: "",
    custeador: "",
    VooChegada: "",
    CidadeChegada: "",
    dataSaida: "",
    VooSaida: "",
    CidadeSaida: "",
    itinerioCidades: [""], // já começa com um campo vazio

    // Endereço pessoal separado
    endereco: "",
    bairro: "",
    cidade: "",
    estadoCasa: "",
    cep: "",
    emails: [""],
    telefones: [""],
    redesSociais: [],

    ocupacaoAtual: "",
    ocupacaoAtualSelect: "",

    explicacaoDesempregado: "",
    empresa: "",
    dataInicio: "",
    // Endereço da empresa separado
    enderecoEmpresa: "",
    bairroEmpresa: "",
    cidadeEmpresa: "",
    estadoEmpresa: "",
    cepEmpresa: "",

    telefoneEmpresa: "",
    rendaMensal: "",
    funcao: "",
    explicacaoFuncao: "",
    trabalhoAutonomoOuEmpresa: "",
    meiCnpj: "",
    ocupacaoAnterior: [],
    formacaoAcademica: [],
    idiomas: "",

    // Dados do sponsor separados
    sponsorNome: "",
    sponsorSobreNome: "",
    sponsorTelefone: "",
    sponsorEmail: "",
    sponsorParentesco: "",
    sponsorEndereco: "",
    sponsorBairro: "",
    sponsorCidade: "",
    sponsorEstado: "",
    sponsorCep: "",

    acompanhantes: [],
    socialSecurity: "",
    idFiscalEUA: "",
    esteveEUA: "",
    viagensEUA: [],

    carteiraHabilitacao: "",
    teveVisto: "",
    copiaVistoAnterior: null,
    ultimoVistoNumero: "",
    ultimoVistoCategoria: "",
    ultimoVistoDataEmissao: "",
    ultimoVistoDataExpiracao: "",
    vistoCancelado: "",
    vistoNegado: "",
    peticaoImigracao: "",
    vistoRoubadoPerdido: "",
    carteiradeHabilitacao: "",
    detalhesVistoNegado: "",

    dataEntradaEUA: "",
    duracaoEUA: "",
    possuiSocialSecurity: "",
    possuiIdFiscalEUA: "",

    // Dados da família
    nomePai: "",
    sobrenomePai: "",
    dataNascimentoPai: "",
    desconheceNomePai: "",
    desconheceDataNascimentoPai: "",
    nomeMae: "",
    sobrenomeMae: "",
    dataNascimentoMae: "",
    desconheceNomeMae: "",
    desconheceDataNascimentoMae: "",
    parenteImediatoEUA: "",
    parenteEUA: "",
    parentesImediatos: [],

    // Contato nos EUA separado
    contatoEUA: "",
    nomeContatoEUA: "",
    sobreNomeContatoEUA: "",

    relacaoContatoEUA: "",
    enderecoContatoEUA: "",
    bairroContatoEUA: "",
    cidadeContatoEUA: "",
    estadoContatoEUA: "",
    cepContatoEUA: "",
    telefoneContatoEUA: "",
    emailContatoEUA: "",

    // Dados do passaporte
    dataEmissaoPassaporte: "",
    dataExpiracaoPassaporte: "",
    numeroPassaporte: "",
    numeroPassaporteOutraNacionalidade: "",
    cidadeEstadoEmissaoPassaporte: "",
    passaporteRoubadoPerdido: "",
    numeroPassaportePerdido: "",
    paisEmissaoPassaportePerdido: "",
    detalhesPassaportePerdido: "",

    nomeConjuge: "",
    sobreNomeConjuge: "",
    dataNascimentoConjuge: "",
    localNascimentoConjuge: "",
    enderecoConjuge: "",
    divorcios: [],

    idiomasFalados: [],
    viagensRecentes: [],
    organizacoes: [],
    habilidadesEspeciais: "",
    condenacoes: "",

    prestouMilitar: "",
    servicoMilitarPais: "",
    servicoMilitarBatalhao: "",
    servicoMilitarPosicao: "",
    servicoMilitarEspecialidade: "",
    servicoMilitarDataInicio: "",
    servicoMilitarDataTermino: "",

    temdoenca: "",
    doenca: "",

    temCondenacoes: "",
    temHabilidadesEspeciais: "",
    participaOrganizacoes: "",
  };

  const [formData, setFormData] = useState(initialState);
  // Função para atualizar o estado do formulário
  const setFormField = (field, value) => {
    if (typeof field === "object") {
      setFormData((prevData) => ({ ...prevData, ...field })); // Atualização em massa
    } else {
      setFormData((prevData) => ({ ...prevData, [field]: value })); // Atualização de um campo
    }
  };
  return [formData, setFormField];
}

export const sanitizeNumberInput = (e, callback) => {
  const onlyNumbers = e.target.value.replace(/\D/g, "");
  callback({
    target: {
      name: e.target.name,
      value: onlyNumbers,
    },
  });
};

export const estados = [
  { value: "", label: "- Select one -" },
  { value: "AL", label: "ALABAMA" },
  { value: "AK", label: "ALASKA" },
  { value: "AS", label: "AMERICAN SAMOA" },
  { value: "AZ", label: "ARIZONA" },
  { value: "AR", label: "ARKANSAS" },
  { value: "CA", label: "CALIFORNIA" },
  { value: "CO", label: "COLORADO" },
  { value: "CT", label: "CONNECTICUT" },
  { value: "DE", label: "DELAWARE" },
  { value: "DC", label: "DISTRICT OF COLUMBIA" },
  { value: "FL", label: "FLORIDA" },
  { value: "GA", label: "GEORGIA" },
  { value: "GU", label: "GUAM" },
  { value: "HI", label: "HAWAII" },
  { value: "ID", label: "IDAHO" },
  { value: "IL", label: "ILLINOIS" },
  { value: "IN", label: "INDIANA" },
  { value: "IA", label: "IOWA" },
  { value: "KS", label: "KANSAS" },
  { value: "KY", label: "KENTUCKY" },
  { value: "LA", label: "LOUISIANA" },
  { value: "ME", label: "MAINE" },
  { value: "MD", label: "MARYLAND" },
  { value: "MA", label: "MASSACHUSETTS" },
  { value: "MI", label: "MICHIGAN" },
  { value: "MN", label: "MINNESOTA" },
  { value: "MS", label: "MISSISSIPPI" },
  { value: "MO", label: "MISSOURI" },
  { value: "MT", label: "MONTANA" },
  { value: "NE", label: "NEBRASKA" },
  { value: "NV", label: "NEVADA" },
  { value: "NH", label: "NEW HAMPSHIRE" },
  { value: "NJ", label: "NEW JERSEY" },
  { value: "NM", label: "NEW MEXICO" },
  { value: "NY", label: "NEW YORK" },
  { value: "NC", label: "NORTH CAROLINA" },
  { value: "ND", label: "NORTH DAKOTA" },
  { value: "MP", label: "NORTHERN MARIANA ISLANDS" },
  { value: "OH", label: "OHIO" },
  { value: "OK", label: "OKLAHOMA" },
  { value: "OR", label: "OREGON" },
  { value: "PA", label: "PENNSYLVANIA" },
  { value: "PR", label: "PUERTO RICO" },
  { value: "RI", label: "RHODE ISLAND" },
  { value: "SC", label: "SOUTH CAROLINA" },
  { value: "SD", label: "SOUTH DAKOTA" },
  { value: "TN", label: "TENNESSEE" },
  { value: "TX", label: "TEXAS" },
  { value: "UT", label: "UTAH" },
  { value: "VT", label: "VERMONT" },
  { value: "VI", label: "VIRGIN ISLANDS" },
  { value: "VA", label: "VIRGINIA" },
  { value: "WA", label: "WASHINGTON" },
  { value: "WV", label: "WEST VIRGINIA" },
  { value: "WI", label: "WISCONSIN" },
  { value: "WY", label: "WYOMING" },
];

// src/constants/estados.js
export const estadosBrasileiros = [
  { value: "Acre", label: "Acre" },
  { value: "Alagoas", label: "Alagoas" },
  { value: "Amapa", label: "Amapá" },
  { value: "Amazonas", label: "Amazonas" },
  { value: "Bahia", label: "Bahia" },
  { value: "Ceara", label: "Ceará" },
  { value: "Distrito Federal", label: "Distrito Federal" },
  { value: "Espirito Santo", label: "Espírito Santo" },
  { value: "Goias", label: "Goiás" },
  { value: "Maranhao", label: "Maranhão" },
  { value: "Mato Grosso", label: "Mato Grosso" },
  { value: "Mato Grosso do Sul", label: "Mato Grosso do Sul" },
  { value: "Minas Gerais", label: "Minas Gerais" },
  { value: "Para", label: "Pará" },
  { value: "Paraiba", label: "Paraíba" },
  { value: "Parana", label: "Paraná" },
  { value: "Pernambuco", label: "Pernambuco" },
  { value: "Piaui", label: "Piauí" },
  { value: "Rio De Janeiro", label: "Rio de Janeiro" },
  { value: "Rio Grande do Norte", label: "Rio Grande do Norte" },
  { value: "Rio Grande do Sul", label: "Rio Grande do Sul" },
  { value: "Rondonia", label: "Rondônia" },
  { value: "Roraima", label: "Roraima" },
  { value: "Santa Catarina", label: "Santa Catarina" },
  { value: "SaoPaulo", label: "São Paulo" },
  { value: "Sergipe", label: "Sergipe" },
  { value: "Tocantins", label: "Tocantins" },
];

export const nacionalidades = [
  { value: "AFGH", label: "AFGHANISTAN" },
  { value: "ALB", label: "ALBANIA" },
  { value: "ALGR", label: "ALGERIA" },
  { value: "ASMO", label: "AMERICAN SAMOA" },
  { value: "ANDO", label: "ANDORRA" },
  { value: "ANGL", label: "ANGOLA" },
  { value: "ANGU", label: "ANGUILLA" },
  { value: "ANTI", label: "ANTIGUA AND BARBUDA" },
  { value: "ARG", label: "ARGENTINA" },
  { value: "ARM", label: "ARMENIA" },
  { value: "ARB", label: "ARUBA" },
  { value: "XAS", label: "AT SEA" },
  { value: "ASTL", label: "AUSTRALIA" },
  { value: "AUST", label: "AUSTRIA" },
  { value: "AZR", label: "AZERBAIJAN" },
  { value: "BAMA", label: "BAHAMAS" },
  { value: "BAHR", label: "BAHRAIN" },
  { value: "BANG", label: "BANGLADESH" },
  { value: "BRDO", label: "BARBADOS" },
  { value: "BYS", label: "BELARUS" },
  { value: "BELG", label: "BELGIUM" },
  { value: "BLZ", label: "BELIZE" },
  { value: "BENN", label: "BENIN" },
  { value: "BERM", label: "BERMUDA" },
  { value: "BHU", label: "BHUTAN" },
  { value: "BOL", label: "BOLIVIA" },
  { value: "BIH", label: "BOSNIA-HERZEGOVINA" },
  { value: "BOT", label: "BOTSWANA" },
  { value: "BRZL", label: "BRAZIL" },
  { value: "IOT", label: "BRITISH INDIAN OCEAN TERRITORY" },
  { value: "BRNI", label: "BRUNEI" },
  { value: "BULG", label: "BULGARIA" },
  { value: "BURK", label: "BURKINA FASO" },
  { value: "BURM", label: "BURMA" },
  { value: "BRND", label: "BURUNDI" },
  { value: "CBDA", label: "CAMBODIA" },
  { value: "CMRN", label: "CAMEROON" },
  { value: "CAN", label: "CANADA" },
  { value: "CAVI", label: "CABO VERDE" },
  { value: "CAYI", label: "CAYMAN ISLANDS" },
  { value: "CAFR", label: "CENTRAL AFRICAN REPUBLIC" },
  { value: "CHAD", label: "CHAD" },
  { value: "CHIL", label: "CHILE" },
  { value: "CHIN", label: "CHINA" },
  { value: "CHRI", label: "CHRISTMAS ISLAND" },
  { value: "COCI", label: "COCOS KEELING ISLANDS" },
  { value: "COL", label: "COLOMBIA" },
  { value: "COMO", label: "COMOROS" },
  { value: "COD", label: "CONGO, DEMOCRATIC REPUBLIC OF THE" },
  { value: "CONB", label: "CONGO, REPUBLIC OF THE" },
  { value: "CKIS", label: "COOK ISLANDS" },
  { value: "CSTR", label: "COSTA RICA" },
  { value: "IVCO", label: "COTE D`IVOIRE" },
  { value: "HRV", label: "CROATIA" },
  { value: "CUBA", label: "CUBA" },
  { value: "CUR", label: "CURACAO" },
  { value: "CYPR", label: "CYPRUS" },
  { value: "CZEC", label: "CZECH REPUBLIC" },
  { value: "DEN", label: "DENMARK" },
  { value: "DJI", label: "DJIBOUTI" },
  { value: "DOMN", label: "DOMINICA" },
  { value: "DOMR", label: "DOMINICAN REPUBLIC" },
  { value: "ECUA", label: "ECUADOR" },
  { value: "EGYP", label: "EGYPT" },
  { value: "ELSL", label: "EL SALVADOR" },
  { value: "EGN", label: "EQUATORIAL GUINEA" },
  { value: "ERI", label: "ERITREA" },
  { value: "EST", label: "ESTONIA" },
  { value: "SZLD", label: "ESWATINI" },
  { value: "ETH", label: "ETHIOPIA" },
  { value: "FKLI", label: "FALKLAND ISLANDS" },
  { value: "FRO", label: "FAROE ISLANDS" },
  { value: "FIJI", label: "FIJI" },
  { value: "FIN", label: "FINLAND" },
  { value: "FRAN", label: "FRANCE" },
  { value: "FPOL", label: "FRENCH POLYNESIA" },
  { value: "FSAT", label: "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES" },
  { value: "GABN", label: "GABON" },
  { value: "GAM", label: "GAMBIA, THE" },
  { value: "XGZ", label: "GAZA STRIP" },
  { value: "GEO", label: "GEORGIA" },
  { value: "GER", label: "GERMANY" },
  { value: "GHAN", label: "GHANA" },
  { value: "GIB", label: "GIBRALTAR" },
  { value: "GRC", label: "GREECE" },
  { value: "GRLD", label: "GREENLAND" },
  { value: "GREN", label: "GRENADA" },
  { value: "GUAM", label: "GUAM" },
  { value: "GUAT", label: "GUATEMALA" },
  { value: "GNEA", label: "GUINEA" },
  { value: "GUIB", label: "GUINEA - BISSAU" },
  { value: "GUY", label: "GUYANA" },
  { value: "HAT", label: "HAITI" },
  { value: "HMD", label: "HEARD AND MCDONALD ISLANDS" },
  { value: "VAT", label: "HOLY SEE (VATICAN CITY)" },
  { value: "HOND", label: "HONDURAS" },
  { value: "HOKO", label: "HONG KONG BNO" },
  { value: "HNK", label: "HONG KONG SAR" },
  { value: "XHI", label: "HOWLAND ISLAND" },
  { value: "HUNG", label: "HUNGARY" },
  { value: "ICLD", label: "ICELAND" },
  { value: "XIR", label: "IN THE AIR" },
  { value: "IND", label: "INDIA" },
  { value: "IDSA", label: "INDONESIA" },
  { value: "IRAN", label: "IRAN" },
  { value: "IRAQ", label: "IRAQ" },
  { value: "IRE", label: "IRELAND" },
  { value: "ISRL", label: "ISRAEL" },
  { value: "ITLY", label: "ITALY" },
  { value: "JAM", label: "JAMAICA" },
  { value: "JPN", label: "JAPAN" },
  { value: "JRSM", label: "JERUSALEM" },
  { value: "JORD", label: "JORDAN" },
  { value: "KAZ", label: "KAZAKHSTAN" },
  { value: "KENY", label: "KENYA" },
  { value: "KIRI", label: "KIRIBATI" },
  { value: "PRK", label: "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)" },
  { value: "KOR", label: "KOREA, REPUBLIC OF (SOUTH)" },
  { value: "KSV", label: "KOSOVO" },
  { value: "KUWT", label: "KUWAIT" },
  { value: "KGZ", label: "KYRGYZSTAN" },
  { value: "LAOS", label: "LAOS" },
  { value: "LATV", label: "LATVIA" },
  { value: "LEBN", label: "LEBANON" },
  { value: "LES", label: "LESOTHO" },
  { value: "LIBR", label: "LIBERIA" },
  { value: "LBYA", label: "LIBYA" },
  { value: "LCHT", label: "LIECHTENSTEIN" },
  { value: "LITH", label: "LITHUANIA" },
  { value: "LXM", label: "LUXEMBOURG" },
  { value: "MAC", label: "MACAU" },
  { value: "MKD", label: "MACEDONIA, NORTH" },
  { value: "MADG", label: "MADAGASCAR" },
  { value: "MALW", label: "MALAWI" },
  { value: "MLAS", label: "MALAYSIA" },
  { value: "MLDI", label: "MALDEN ISLAND" },
  { value: "MLDV", label: "MALDIVES" },
  { value: "MALI", label: "MALI" },
  { value: "MLTA", label: "MALTA" },
  { value: "RMI", label: "MARSHALL ISLANDS" },
  { value: "MAUR", label: "MAURITANIA" },
  { value: "MRTS", label: "MAURITIUS" },
  { value: "MYT", label: "MAYOTTE" },
  { value: "AGS", label: "MEXICO - AGUASCALIENTES" },
  { value: "BC", label: "MEXICO - BAJA CALIFORNIA NORTE" },
  { value: "BCSR", label: "MEXICO - BAJA CALIFORNIA SUR" },
  { value: "CAMP", label: "MEXICO - CAMPECHE" },
  { value: "CHIS", label: "MEXICO - CHIAPAS" },
  { value: "CHIH", label: "MEXICO - CHIHUAHUA" },
  { value: "COAH", label: "MEXICO - COAHUILA" },
  { value: "COLI", label: "MEXICO - COLIMA" },
  { value: "DF", label: "MEXICO - DISTRITO FEDERAL" },
  { value: "DGO", label: "MEXICO - DURANGO" },
  { value: "GTO", label: "MEXICO - GUANAJUATO" },
  { value: "GRO", label: "MEXICO - GUERRERO" },
  { value: "HGO", label: "MEXICO - HIDALGO" },
  { value: "JAL", label: "MEXICO - JALISCO" },
  { value: "MCH", label: "MEXICO - MICHOACAN" },
  { value: "MOR", label: "MEXICO - MORELOS" },
  { value: "NAY", label: "MEXICO - NAYARIT" },
  { value: "NL", label: "MEXICO - NUEVO LEON" },
  { value: "OAX", label: "MEXICO - OAXACA" },
  { value: "PUE", label: "MEXICO - PUEBLA" },
  { value: "QRO", label: "MEXICO - QUERETARO" },
  { value: "QROO", label: "MEXICO - QUINTANA ROO" },
  { value: "SLP", label: "MEXICO - SAN LUIS POTOSI" },
  { value: "SIN", label: "MEXICO - SINALOA" },
  { value: "SON", label: "MEXICO - SONORA" },
  { value: "MXCO", label: "MEXICO - STATE OF MEXICO" },
  { value: "TAB", label: "MEXICO - TABASCO" },
  { value: "TAMP", label: "MEXICO - TAMAULIPAS" },
  { value: "TLAX", label: "MEXICO - TLAXCALA" },
  { value: "VER", label: "MEXICO - VERACRUZ" },
  { value: "YUC", label: "MEXICO - YUCATAN" },
  { value: "ZAC", label: "MEXICO - ZACATECAS" },
  { value: "FSM", label: "MICRONESIA" },
  { value: "MDWI", label: "MIDWAY ISLANDS" },
  { value: "MLD", label: "MOLDOVA" },
  { value: "MON", label: "MONACO" },
  { value: "MONG", label: "MONGOLIA" },
  { value: "MTG", label: "MONTENEGRO" },
  { value: "MONT", label: "MONTSERRAT" },
  { value: "MORO", label: "MOROCCO" },
  { value: "MOZ", label: "MOZAMBIQUE" },
  { value: "NAMB", label: "NAMIBIA" },
  { value: "NAU", label: "NAURU" },
  { value: "NEP", label: "NEPAL" },
  { value: "NETH", label: "NETHERLANDS" },
  { value: "NCAL", label: "NEW CALEDONIA" },
  { value: "NZLD", label: "NEW ZEALAND" },
  { value: "NIC", label: "NICARAGUA" },
  { value: "NIR", label: "NIGER" },
  { value: "NRA", label: "NIGERIA" },
  { value: "NIUE", label: "NIUE" },
  { value: "NFK", label: "NORFOLK ISLAND" },
  { value: "MNP", label: "NORTH MARIANA ISLANDS" },
  { value: "NIRE", label: "NORTHERN IRELAND" },
  { value: "NORW", label: "NORWAY" },
  { value: "OMAN", label: "OMAN" },
  { value: "PKST", label: "PAKISTAN" },
  { value: "PALA", label: "PALAU" },
  { value: "PLMR", label: "PALMYRA ATOLL" },
  { value: "PAN", label: "PANAMA" },
  { value: "PNG", label: "PAPUA NEW GUINEA" },
  { value: "PARA", label: "PARAGUAY" },
  { value: "PERU", label: "PERU" },
  { value: "PHIL", label: "PHILIPPINES" },
  { value: "PITC", label: "PITCAIRN ISLANDS" },
  { value: "POL", label: "POLAND" },
  { value: "PORT", label: "PORTUGAL" },
  { value: "PR", label: "PUERTO RICO" },
  { value: "QTAR", label: "QATAR" },
  { value: "ROM", label: "ROMANIA" },
  { value: "RUS", label: "RUSSIA" },
  { value: "RWND", label: "RWANDA" },
  { value: "MAF", label: "SAINT MARTIN" },
  { value: "WSAM", label: "SAMOA" },
  { value: "SMAR", label: "SAN MARINO" },
  { value: "STPR", label: "SAO TOME AND PRINCIPE" },
  { value: "SARB", label: "SAUDI ARABIA" },
  { value: "SENG", label: "SENEGAL" },
  { value: "SBA", label: "SERBIA" },
  { value: "SEYC", label: "SEYCHELLES" },
  { value: "SLEO", label: "SIERRA LEONE" },
  { value: "SING", label: "SINGAPORE" },
  { value: "STM", label: "SINT MAARTEN" },
  { value: "SVK", label: "SLOVAKIA" },
  { value: "SVN", label: "SLOVENIA" },
  { value: "SLMN", label: "SOLOMON ISLANDS" },
  { value: "SOMA", label: "SOMALIA" },
  { value: "SAFR", label: "SOUTH AFRICA" },
  { value: "SGS", label: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND" },
  { value: "SSDN", label: "SOUTH SUDAN" },
  { value: "SPN", label: "SPAIN" },
  { value: "SRL", label: "SRI LANKA" },
  { value: "STBR", label: "ST. BARTHELEMY" },
  { value: "SHEL", label: "ST. HELENA" },
  { value: "STCN", label: "ST. KITTS AND NEVIS" },
  { value: "SLCA", label: "ST. LUCIA" },
  { value: "SPMI", label: "ST. PIERRE AND MIQUELON" },
  { value: "STVN", label: "ST. VINCENT AND THE GRENADINES" },
  { value: "SUDA", label: "SUDAN" },
  { value: "SURM", label: "SURINAME" },
  { value: "SJM", label: "SVALBARD" },
  { value: "SWDN", label: "SWEDEN" },
  { value: "SWTZ", label: "SWITZERLAND" },
  { value: "SYR", label: "SYRIA" },
  { value: "TWAN", label: "TAIWAN" },
  { value: "TJK", label: "TAJIKISTAN" },
  { value: "TAZN", label: "TANZANIA" },
  { value: "THAI", label: "THAILAND" },
  { value: "TMOR", label: "TIMOR-LESTE" },
  { value: "TOGO", label: "TOGO" },
  { value: "TKL", label: "TOKELAU" },
  { value: "TONG", label: "TONGA" },
  { value: "TRIN", label: "TRINIDAD AND TOBAGO" },
  { value: "TNSA", label: "TUNISIA" },
  { value: "TRKY", label: "TURKEY" },
  { value: "TKM", label: "TURKMENISTAN" },
  { value: "TCIS", label: "TURKS AND CAICOS ISLANDS" },
  { value: "TUV", label: "TUVALU" },
  { value: "UGAN", label: "UGANDA" },
  { value: "UKR", label: "UKRAINE" },
  { value: "UAE", label: "UNITED ARAB EMIRATES" },
  { value: "GRBR", label: "UNITED KINGDOM" },
  { value: "USA", label: "UNITED STATES OF AMERICA" },
  { value: "URU", label: "URUGUAY" },
  { value: "UZB", label: "UZBEKISTAN" },
  { value: "VANU", label: "VANUATU" },
  { value: "VENZ", label: "VENEZUELA" },
  { value: "VTNM", label: "VIETNAM" },
  { value: "VI", label: "VIRGIN ISLANDS (U.S.)" },
  { value: "BRVI", label: "VIRGIN ISLANDS, BRITISH" },
  { value: "WKI", label: "WAKE ISLAND" },
  { value: "WAFT", label: "WALLIS AND FUTUNA ISLANDS" },
  { value: "XWB", label: "WEST BANK" },
  { value: "SSAH", label: "WESTERN SAHARA" },
  { value: "YEM", label: "YEMEN" },
  { value: "ZAMB", label: "ZAMBIA" },
  { value: "ZIMB", label: "ZIMBABWE" },
];

export const paisesMundo = [
  { label: "- Select One -", value: "" },
  { label: "AFGHANISTAN", value: "AFGH" },
  { label: "ALBANIA", value: "ALB" },
  { label: "ALGERIA", value: "ALGR" },
  { label: "AMERICAN SAMOA", value: "ASMO" },
  { label: "ANDORRA", value: "ANDO" },
  { label: "ANGOLA", value: "ANGL" },
  { label: "ANGUILLA", value: "ANGU" },
  { label: "ANTIGUA AND BARBUDA", value: "ANTI" },
  { label: "ARGENTINA", value: "ARG" },
  { label: "ARMENIA", value: "ARM" },
  { label: "ARUBA", value: "ARB" },
  { label: "AUSTRALIA", value: "ASTL" },
  { label: "AUSTRIA", value: "AUST" },
  { label: "AZERBAIJAN", value: "AZR" },
  { label: "BAHAMAS", value: "BAMA" },
  { label: "BAHRAIN", value: "BAHR" },
  { label: "BANGLADESH", value: "BANG" },
  { label: "BARBADOS", value: "BRDO" },
  { label: "BELARUS", value: "BYS" },
  { label: "BELGIUM", value: "BELG" },
  { label: "BELIZE", value: "BLZ" },
  { label: "BENIN", value: "BENN" },
  { label: "BERMUDA", value: "BERM" },
  { label: "BHUTAN", value: "BHU" },
  { label: "BOLIVIA", value: "BOL" },
  { label: "BONAIRE", value: "BON" },
  { label: "BOSNIA-HERZEGOVINA", value: "BIH" },
  { label: "BOTSWANA", value: "BOT" },
  { label: "BRAZIL", value: "BRZL" },
  { label: "BRITISH INDIAN OCEAN TERRITORY", value: "IOT" },
  { label: "BRUNEI", value: "BRNI" },
  { label: "BULGARIA", value: "BULG" },
  { label: "BURKINA FASO", value: "BURK" },
  { label: "BURMA", value: "BURM" },
  { label: "BURUNDI", value: "BRND" },
  { label: "CAMBODIA", value: "CBDA" },
  { label: "CAMEROON", value: "CMRN" },
  { label: "CANADA", value: "CAN" },
  { label: "CABO VERDE", value: "CAVI" },
  { label: "CAYMAN ISLANDS", value: "CAYI" },
  { label: "CENTRAL AFRICAN REPUBLIC", value: "CAFR" },
  { label: "CHAD", value: "CHAD" },
  { label: "CHILE", value: "CHIL" },
  { label: "CHINA", value: "CHIN" },
  { label: "CHRISTMAS ISLAND", value: "CHRI" },
  { label: "COCOS KEELING ISLANDS", value: "COCI" },
  { label: "COLOMBIA", value: "COL" },
  { label: "COMOROS", value: "COMO" },
  { label: "CONGO, DEMOCRATIC REPUBLIC OF THE", value: "COD" },
  { label: "CONGO, REPUBLIC OF THE", value: "CONB" },
  { label: "COOK ISLANDS", value: "CKIS" },
  { label: "COSTA RICA", value: "CSTR" },
  { label: "COTE D`IVOIRE", value: "IVCO" },
  { label: "CROATIA", value: "HRV" },
  { label: "CUBA", value: "CUBA" },
  { label: "CURACAO", value: "CUR" },
  { label: "CYPRUS", value: "CYPR" },
  { label: "CZECH REPUBLIC", value: "CZEC" },
  { label: "DENMARK", value: "DEN" },
  { label: "DJIBOUTI", value: "DJI" },
  { label: "DOMINICA", value: "DOMN" },
  { label: "DOMINICAN REPUBLIC", value: "DOMR" },
  { label: "ECUADOR", value: "ECUA" },
  { label: "EGYPT", value: "EGYP" },
  { label: "EL SALVADOR", value: "ELSL" },
  { label: "EQUATORIAL GUINEA", value: "EGN" },
  { label: "ERITREA", value: "ERI" },
  { label: "ESTONIA", value: "EST" },
  { label: "ESWATINI", value: "SZLD" },
  { label: "ETHIOPIA", value: "ETH" },
  { label: "FALKLAND ISLANDS", value: "FKLI" },
  { label: "FAROE ISLANDS", value: "FRO" },
  { label: "FIJI", value: "FIJI" },
  { label: "FINLAND", value: "FIN" },
  { label: "FRANCE", value: "FRAN" },
  { label: "FRENCH GUIANA", value: "FRGN" },
  { label: "FRENCH POLYNESIA", value: "FPOL" },
  { label: "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES", value: "FSAT" },
  { label: "GABON", value: "GABN" },
  { label: "GAMBIA, THE", value: "GAM" },
  { label: "GAZA STRIP", value: "XGZ" },
  { label: "GEORGIA", value: "GEO" },
  { label: "GERMANY", value: "GER" },
  { label: "GHANA", value: "GHAN" },
  { label: "GIBRALTAR", value: "GIB" },
  { label: "GREECE", value: "GRC" },
  { label: "GREENLAND", value: "GRLD" },
  { label: "GRENADA", value: "GREN" },
  { label: "GUADELOUPE", value: "GUAD" },
  { label: "GUAM", value: "GUAM" },
  { label: "GUATEMALA", value: "GUAT" },
  { label: "GUINEA", value: "GNEA" },
  { label: "GUINEA - BISSAU", value: "GUIB" },
  { label: "GUYANA", value: "GUY" },
  { label: "HAITI", value: "HAT" },
  { label: "HEARD AND MCDONALD ISLANDS", value: "HMD" },
  { label: "HOLY SEE (VATICAN CITY)", value: "VAT" },
  { label: "HONDURAS", value: "HOND" },
  { label: "HONG KONG", value: "HNK" },
  { label: "HOWLAND ISLAND", value: "XHI" },
  { label: "HUNGARY", value: "HUNG" },
  { label: "ICELAND", value: "ICLD" },
  { label: "INDIA", value: "IND" },
  { label: "INDONESIA", value: "IDSA" },
  { label: "IRAN", value: "IRAN" },
  { label: "IRAQ", value: "IRAQ" },
  { label: "IRELAND", value: "IRE" },
  { label: "ISRAEL", value: "ISRL" },
  { label: "ITALY", value: "ITLY" },
  { label: "JAMAICA", value: "JAM" },
  { label: "JAPAN", value: "JPN" },
  { label: "JERUSALEM", value: "JRSM" },
  { label: "JORDAN", value: "JORD" },
  { label: "KAZAKHSTAN", value: "KAZ" },
  { label: "KENYA", value: "KENY" },
  { label: "KIRIBATI", value: "KIRI" },
  { label: "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)", value: "PRK" },
  { label: "KOREA, REPUBLIC OF (SOUTH)", value: "KOR" },
  { label: "KOSOVO", value: "KSV" },
  { label: "KUWAIT", value: "KUWT" },
  { label: "KYRGYZSTAN", value: "KGZ" },
  { label: "LAOS", value: "LAOS" },
  { label: "LATVIA", value: "LATV" },
  { label: "LEBANON", value: "LEBN" },
  { label: "LESOTHO", value: "LES" },
  { label: "LIBERIA", value: "LIBR" },
  { label: "LIBYA", value: "LBYA" },
  { label: "LIECHTENSTEIN", value: "LCHT" },
  { label: "LITHUANIA", value: "LITH" },
  { label: "LUXEMBOURG", value: "LXM" },
  { label: "MACAU", value: "MAC" },
  { label: "MACEDONIA, NORTH", value: "MKD" },
  { label: "MADAGASCAR", value: "MADG" },
  { label: "MALAWI", value: "MALW" },
  { label: "MALAYSIA", value: "MLAS" },
  { label: "MALDEN ISLAND", value: "MLDI" },
  { label: "MALDIVES", value: "MLDV" },
  { label: "MALI", value: "MALI" },
  { label: "MALTA", value: "MLTA" },
  { label: "MARSHALL ISLANDS", value: "RMI" },
  { label: "MARTINIQUE", value: "MART" },
  { label: "MAURITANIA", value: "MAUR" },
  { label: "MAURITIUS", value: "MRTS" },
  { label: "MAYOTTE", value: "MYT" },
  { label: "MEXICO", value: "MEX" },
  { label: "MICRONESIA", value: "FSM" },
  { label: "MIDWAY ISLANDS", value: "MDWI" },
  { label: "MOLDOVA", value: "MLD" },
  { label: "MONACO", value: "MON" },
  { label: "MONGOLIA", value: "MONG" },
  { label: "MONTENEGRO", value: "MTG" },
  { label: "MONTSERRAT", value: "MONT" },
  { label: "MOROCCO", value: "MORO" },
  { label: "MOZAMBIQUE", value: "MOZ" },
  { label: "NAMIBIA", value: "NAMB" },
  { label: "NAURU", value: "NAU" },
  { label: "NEPAL", value: "NEP" },
  { label: "NETHERLANDS", value: "NETH" },
  { label: "NEW CALEDONIA", value: "NCAL" },
  { label: "NEW ZEALAND", value: "NZLD" },
  { label: "NICARAGUA", value: "NIC" },
  { label: "NIGER", value: "NIR" },
  { label: "NIGERIA", value: "NRA" },
  { label: "NIUE", value: "NIUE" },
  { label: "NORFOLK ISLAND", value: "NFK" },
  { label: "NORTH MARIANA ISLANDS", value: "MNP" },
  { label: "NORTHERN IRELAND", value: "NIRE" },
  { label: "NORWAY", value: "NORW" },
  { label: "OMAN", value: "OMAN" },
  { label: "PAKISTAN", value: "PKST" },
  { label: "PALAU", value: "PALA" },
  { label: "PALMYRA ATOLL", value: "PLMR" },
  { label: "PANAMA", value: "PAN" },
  { label: "PAPUA NEW GUINEA", value: "PNG" },
  { label: "PARAGUAY", value: "PARA" },
  { label: "PERU", value: "PERU" },
  { label: "PHILIPPINES", value: "PHIL" },
  { label: "PITCAIRN ISLANDS", value: "PITC" },
  { label: "POLAND", value: "POL" },
  { label: "PORTUGAL", value: "PORT" },
  { label: "PUERTO RICO", value: "PR" },
  { label: "QATAR", value: "QTAR" },
  { label: "REUNION", value: "REUN" },
  { label: "ROMANIA", value: "ROM" },
  { label: "RUSSIA", value: "RUS" },
  { label: "RWANDA", value: "RWND" },
  { label: "SABA ISLAND", value: "SABA" },
  { label: "SAINT MARTIN", value: "MAF" },
  { label: "SAMOA", value: "WSAM" },
  { label: "SAN MARINO", value: "SMAR" },
  { label: "SAO TOME AND PRINCIPE", value: "STPR" },
  { label: "SAUDI ARABIA", value: "SARB" },
  { label: "SENEGAL", value: "SENG" },
  { label: "SERBIA", value: "SBA" },
  { label: "SEYCHELLES", value: "SEYC" },
  { label: "SIERRA LEONE", value: "SLEO" },
  { label: "SINGAPORE", value: "SING" },
  { label: "SINT MAARTEN", value: "STM" },
  { label: "SLOVAKIA", value: "SVK" },
  { label: "SLOVENIA", value: "SVN" },
  { label: "SOLOMON ISLANDS", value: "SLMN" },
  { label: "SOMALIA", value: "SOMA" },
  { label: "SOUTH AFRICA", value: "SAFR" },
  { label: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND", value: "SGS" },
  { label: "SOUTH SUDAN", value: "SSDN" },
  { label: "SPAIN", value: "SPN" },
  { label: "SRI LANKA", value: "SRL" },
  { label: "ST. EUSTATIUS", value: "STEU" },
  { label: "ST. HELENA", value: "SHEL" },
  { label: "ST. KITTS AND NEVIS", value: "STCN" },
  { label: "ST. LUCIA", value: "SLCA" },
  { label: "ST. PIERRE AND MIQUELON", value: "SPMI" },
  { label: "ST. VINCENT AND THE GRENADINES", value: "STVN" },
  { label: "SUDAN", value: "SUDA" },
  { label: "SURINAME", value: "SURM" },
  { label: "SVALBARD", value: "SJM" },
  { label: "SWEDEN", value: "SWDN" },
  { label: "SWITZERLAND", value: "SWTZ" },
  { label: "SYRIA", value: "SYR" },
  { label: "TAIWAN", value: "TWAN" },
  { label: "TAJIKISTAN", value: "TJK" },
  { label: "TANZANIA", value: "TAZN" },
  { label: "THAILAND", value: "THAI" },
  { label: "TIMOR-LESTE", value: "TMOR" },
  { label: "TOGO", value: "TOGO" },
  { label: "TOKELAU", value: "TKL" },
  { label: "TONGA", value: "TONG" },
  { label: "TRINIDAD AND TOBAGO", value: "TRIN" },
  { label: "TUNISIA", value: "TNSA" },
  { label: "TURKEY", value: "TRKY" },
  { label: "TURKMENISTAN", value: "TKM" },
  { label: "TURKS AND CAICOS ISLANDS", value: "TCIS" },
  { label: "TUVALU", value: "TUV" },
  { label: "UGANDA", value: "UGAN" },
  { label: "UKRAINE", value: "UKR" },
  { label: "UNITED ARAB EMIRATES", value: "UAE" },
  { label: "UNITED KINGDOM", value: "GRBR" },
  { label: "UNITED STATES OF AMERICA", value: "USA" },
  { label: "URUGUAY", value: "URU" },
  { label: "UZBEKISTAN", value: "UZB" },
  { label: "VANUATU", value: "VANU" },
  { label: "VENEZUELA", value: "VENZ" },
  { label: "VIETNAM", value: "VTNM" },
  { label: "VIRGIN ISLANDS (U.S.)", value: "VI" },
  { label: "VIRGIN ISLANDS, BRITISH", value: "BRVI" },
  { label: "WAKE ISLAND", value: "WKI" },
  { label: "WALLIS AND FUTUNA ISLANDS", value: "WAFT" },
  { label: "WEST BANK", value: "XWB" },
  { label: "WESTERN SAHARA", value: "SSAH" },
  { label: "YEMEN", value: "YEM" },
  { label: "ZAMBIA", value: "ZAMB" },
  { label: "ZIMBABWE", value: "ZIMB" },
];

// Função que renderiza a etapa de Dados Pessoais
export function PersonalInformation1({
  formData,
  handleInputChange,
  errors,
  addEntry,
  removeEntry,
}) {
  return (
    <div
    // style={{width: "100%"}}
    >
      <h2>Dados Pessoais</h2>
      <div>
        <label>
          Nome:
          {formData.nome && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.nome.length} / 33
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="nome"
          value={formData.nome}
          onChange={handleInputChange}
          maxLength={33}
        />
        {/* {errors.nome && <span>{errors.nome}</span>} */}
      </div>
      <div>
        <label>
          Sobrenome:
          {formData.sobrenome && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.sobrenome.length} / 33
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="sobrenome"
          value={formData.sobrenome}
          onChange={handleInputChange}
          maxLength={33}
        />
        {/* {errors.sobrenome && <span>{errors.sobrenome}</span>} */}
      </div>

      <label style={{ width: "100%" }}>
        Já fez alguma alteração no nome ou sobrenome?
      </label>
      <div
      // style={{display: "flex"}}
      >
        <div
        // style={{width: "50%"}}
        >
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="alteracaoNome"
            value="nao"
            checked={formData.alteracaoNome === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div
        // style={{width: "50%"}}
        >
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="alteracaoNome"
            value="sim"
            checked={formData.alteracaoNome === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.alteracaoNome === "sim" && (
          <div>
            <div>
              <label>nome anterior</label>
              <InputField
                errors={errors}
                type="text"
                name="detalhesAlteracaoNome"
                value={formData.detalhesAlteracaoNome}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label>sobrenome anterior</label>
              <InputField
                errors={errors}
                type="text"
                name="detalhesAlteracaoSobreNome"
                value={formData.detalhesAlteracaoSobreNome}
                onChange={handleInputChange}
              />
            </div>
          </div>
        )}

        <div>
          <div>
            <label>Sexo:</label>
          </div>
          <select
            name="sexo"
            value={formData.sexo}
            onChange={handleInputChange}
          >
            <option value="">- Selecione um -</option>
            <option value="M">Homem</option>
            <option value="F">Mulher</option>
          </select>
        </div>
        <div>
          <label>
            Cidade de Nascimento:
            {formData.cidadeNascimento && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {formData.cidadeNascimento.length} / 20
              </span>
            )}
          </label>
          <InputField
            errors={errors}
            type="text"
            name="cidadeNascimento"
            value={formData.cidadeNascimento}
            onChange={handleInputChange}
            maxLength={20}
          />
        </div>
        <div>
          <label>Estado de Nascimento:</label>
          <InputField
            errors={errors}
            type="text"
            name="estadoNascimento"
            value={formData.estadoNascimento}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label>Data de Nascimento:</label>
          <InputField
            errors={errors}
            type="date"
            name="dataNascimento"
            value={formData.dataNascimento}
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label>CPF do solicitante:</label>
          <InputField
            errors={errors}
            type="text"
            name="cpf"
            value={formData.cpf}
            onChange={handleInputChange}
            maxLength={14}
          />
        </div>
        <div>
          <div>
            <label>Estado Civil:</label>
          </div>
          <select
            name="estadoCivil"
            value={formData.estadoCivil}
            onChange={handleInputChange}
          >
            <option value="">- Selecione um -</option>
            <option value="S">Solteiro(a)</option>
            <option value="M">Casado(a)</option>
            <option value="C">
              União Estável/Parceria Civil/União Doméstica
            </option>
            <option value="W">Viúvo(a)</option>
            <option value="D">Divorciado(a)</option>
            <option value="L">Separado(a) Legalmente</option>
            <option value="O">Outro</option>
          </select>
        </div>
        {(formData.estadoCivil === "M" ||
          formData.estadoCivil === "C" ||
          formData.estadoCivil === "W") && (
          <div>
            <h3>Informações sobre Cônjuge Atual</h3>
            <label>Nome (cônjuge):</label>
            <InputField
              errors={errors}
              type="text"
              name="nomeConjuge"
              value={formData.nomeConjuge}
              onChange={handleInputChange}
            />
            <label>Sobrenome (cônjuge):</label>
            <InputField
              errors={errors}
              type="text"
              name="sobreNomeConjuge"
              value={formData.sobreNomeConjuge}
              onChange={handleInputChange}
            />
            <label>Data de nascimento (cônjuge):</label>
            <InputField
              errors={errors}
              type="date"
              name="dataNascimentoConjuge"
              value={formData.dataNascimentoConjuge}
              onChange={handleInputChange}
            />
            <label>Local de nascimento (cônjuge):</label>
            <InputField
              errors={errors}
              type="text"
              name="localNascimentoConjuge"
              value={formData.localNascimentoConjuge}
              onChange={handleInputChange}
            />
            <label>Endereço (cônjuge):</label>
            <InputField
              errors={errors}
              type="text"
              name="enderecoConjuge"
              value={formData.enderecoConjuge}
              onChange={handleInputChange}
            />
          </div>
        )}
        {(formData.estadoCivil === "D" || formData.estadoCivil === "L") && (
          <div>
            <h3>Informe sobre a separação</h3>
            {formData.divorcios.map((divorcio, index) => (
              <div key={index}>
                <h4>{index + 1}° Separação</h4>
                <label>Nome:</label>
                <InputField
                  errors={errors}
                  type="text"
                  name={`nomeDivorcio-${index}`}
                  value={divorcio.nome}
                  onChange={(e) =>
                    handleInputChange(e, index, "divorcios", "nome")
                  }
                />
                <label>Sobrenome:</label>
                <InputField
                  errors={errors}
                  type="text"
                  name={`sobreNomeDivorcio-${index}`}
                  value={divorcio.sobreNome}
                  onChange={(e) =>
                    handleInputChange(e, index, "divorcios", "sobreNome")
                  }
                />
                <label>Data de nascimento:</label>
                <InputField
                  errors={errors}
                  type="date"
                  name={`dataNascimentoDivorcio-${index}`}
                  value={divorcio.dataNascimento}
                  onChange={(e) =>
                    handleInputChange(e, index, "divorcios", "dataNascimento")
                  }
                />
                <label>Local de nascimento:</label>
                <InputField
                  errors={errors}
                  type="text"
                  name={`localNascimentoDivorcio-${index}`}
                  value={divorcio.localNascimento}
                  onChange={(e) =>
                    handleInputChange(e, index, "divorcios", "localNascimento")
                  }
                />
                <label>Data do casamento:</label>
                <InputField
                  errors={errors}
                  type="date"
                  name={`dataCasamentoDivorcio-${index}`}
                  value={divorcio.dataCasamento}
                  onChange={(e) =>
                    handleInputChange(e, index, "divorcios", "dataCasamento")
                  }
                />
                <label>Data do divórcio/separação:</label>
                <InputField
                  errors={errors}
                  type="date"
                  name={`dataDivorcio-${index}`}
                  value={divorcio.dataDivorcio}
                  onChange={(e) =>
                    handleInputChange(e, index, "divorcios", "dataDivorcio")
                  }
                />
                <label>Motivo:</label>
                <textarea
                  className={styles.textareaForm}
                  name={`motivoDivorcio-${index}`}
                  value={divorcio.motivo}
                  onChange={(e) =>
                    handleInputChange(e, index, "divorcios", "motivo")
                  }
                />
                <button
                  style={{
                    color: " red",
                    backgroundColor: "#ffffff00",
                    marginBottom: "20px",
                    padding: "5px",
                    border: "solid 1px  red",
                    borderRadius: "20px",
                  }}
                  type="button"
                  onClick={() => removeEntry("divorcios", index)}
                >
                  - Remover Divórcio
                </button>
              </div>
            ))}
            <button type="button" onClick={() => addEntry("divorcios")}>
              + Adicionar Divórcio
            </button>
          </div>
        )}
      </div>
      {/* <div> */}
      <div>
        <label>
          Você possui ou já possuiu outra nacionalidade além da brasileira?
        </label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="possuiOutraNacionalidade"
            value="nao"
            checked={formData.possuiOutraNacionalidade === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="possuiOutraNacionalidade"
            value="sim"
            checked={formData.possuiOutraNacionalidade === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.possuiOutraNacionalidade === "sim" && (
          <div>
            <label>Especifique a nacionalidade:</label>
            <select
              name="nacionalidade"
              value={formData.nacionalidade}
              onChange={handleInputChange}
            >
              <option value="">- Selecione um país -</option>
              {nacionalidades.map((estado) => (
                <option key={estado.value} value={estado.value}>
                  {estado.label}
                </option>
              ))}
            </select>
            <label>
              Você possui passaporte para o outro país/região de origem
              (nacionalidade) acima?{" "}
            </label>
            <div>
              <InputField
                errors={errors}
                style={{ width: "auto" }}
                type="radio"
                name="possuiOutraNacionalidadePassaporte"
                value="nao"
                checked={formData.possuiOutraNacionalidadePassaporte === "nao"}
                onChange={handleInputChange}
              />
              <label>Não</label>
            </div>
            <div>
              <InputField
                errors={errors}
                style={{ width: "auto" }}
                type="radio"
                name="possuiOutraNacionalidadePassaporte"
                value="sim"
                checked={formData.possuiOutraNacionalidadePassaporte === "sim"}
                onChange={handleInputChange}
              />
              <label>Sim</label>
            </div>
            {formData.possuiOutraNacionalidadePassaporte === "sim" && (
              <div>
                <label>Número do Passaporte (ex: GF123456):</label>
                <InputField
                  errors={errors}
                  type="text"
                  name="numeroPassaporteOutraNacionalidade"
                  value={formData.numeroPassaporteOutraNacionalidade}
                  onChange={handleInputChange}
                />
              </div>
            )}
          </div>
        )}
      </div>
      {/* Continue com os outros campos */}
    </div>
  );
}

// Função que renderiza a etapa de Informações de Viagem
export function InformacoesDeViagem({
  formData,
  handleInputChange,
  errors,
  addEntry,
  removeEntry,
}) {
  const viagemNao = formData.viagemEspecifica === "nao";

  return (
    <div>
      <h2>Informações de Viagem</h2>

      {formData.viagemEspecifica !== "sim" && (
        <div
          style={{
            backgroundColor: "#ffcece",
            borderRadius: "10px",
            flexDirection: "column",
            display: "flex",
            padding: "10px",
            marginTop: "5px",
            marginBottom: "5px",
          }}
        >
          <label style={{ fontSize: ".9rem", marginTop: "0px" }}>
            Ainda não tem uma viagem específica? Sem problema!
          </label>

          <label style={{ fontSize: ".9rem", marginTop: "0px" }}>
            Informe apenas:
          </label>

          <label style={{ fontSize: ".8rem", marginTop: "10px" }}>
            • Que NÃO possui uma viagem específica
          </label>

          <label style={{ fontSize: ".8rem", marginTop: "0px" }}>
            • Uma data pretendida de chegada
          </label>

          <label style={{ fontSize: ".8rem", marginTop: "0px" }}>
            • Uma cidade pretendida
          </label>
        </div>
      )}
      <div>
        <label>Você possui uma viagem específica?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="viagemEspecifica"
            value="sim"
            checked={formData.viagemEspecifica === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="viagemEspecifica"
            value="nao"
            checked={formData.viagemEspecifica === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
      </div>
      {formData.viagemEspecifica === "nao" && (
        <div>
          <div className={styles.obsForm}>
            <div>
              <p>
                É uma simples pretensão de viagem, não necessariamente esta
                viagem obrigatoriamente terá que ser realizada...
              </p>
            </div>
            <div>
              <p>-</p>
            </div>
            <div>
              <p>
                Para quem ainda não decidiu o destino, uma sugestão é indicar
                Orlando (Disney) ou Nova York, que são cidades muito procuradas
                por turistas! ✨
              </p>
            </div>
          </div>

          <h1 style={{ fontSize: "1rem" }}>Pretensão</h1>
          <div>
            <label
              style={{
                fontWeight: viagemNao ? "bold" : "normal",
              }}
            >
              Data pretendida de chegada:
            </label>
            <InputField
              errors={errors}
              type="date"
              name="dataChegada"
              value={formData.dataChegada}
              onChange={handleInputChange}
              style={{
                border: viagemNao ? "2px solid #1f3a8a" : undefined,
                fontWeight: viagemNao ? "bold" : "normal",
              }}
            />
          </div>
          <div>
            <label>Duração da viagem: (EM DIAS)</label>
            <InputField
              errors={errors}
              type="text"
              name="duracaoViagem"
              value={formData.duracaoViagem}
              onChange={handleInputChange}
            />
          </div>
        </div>
      )}
      {formData.viagemEspecifica === "sim" && (
        <div>
          <h1 style={{ fontSize: "1rem" }}>Chegada</h1>
          <div>
            <label>Data pretendida de chegada:</label>
            <InputField
              errors={errors}
              type="date"
              name="dataChegada"
              value={formData.dataChegada}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>
              Voo de chegada (se conhecido)
              {formData.VooChegada && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.VooChegada.length} / 20
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="VooChegada"
              name="VooChegada"
              value={formData.VooChegada}
              onChange={handleInputChange}
              maxLength={20}
            />
          </div>
          <div>
            <label>
              Cidade de chegada
              {formData.CidadeChegada && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.CidadeChegada.length} / 20
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="CidadeChegada"
              name="CidadeChegada"
              value={formData.CidadeChegada}
              onChange={handleInputChange}
              maxLength={20}
            />
          </div>
          <h1 style={{ fontSize: "1rem" }}>Partida</h1>
          <div>
            <label>Data pretendida de Saida:</label>
            <InputField
              errors={errors}
              type="date"
              name="dataSaida"
              value={formData.dataSaida}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label>
              Voo de Saida (se conhecido)
              {formData.VooSaida && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.VooSaida.length} / 20
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="VooSaida"
              name="VooSaida"
              value={formData.VooSaida}
              onChange={handleInputChange}
              maxLength={20}
            />
          </div>
          <div>
            <label>
              Cidade de Saida
              {formData.CidadeSaida && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.CidadeSaida.length} / 20
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="CidadeSaida"
              name="CidadeSaida"
              value={formData.CidadeSaida}
              onChange={handleInputChange}
              maxLength={20}
            />
          </div>
          <h1 style={{ fontSize: "1rem" }}>
            locais que você planeja visitar nos EUA
          </h1>
          {formData.itinerioCidades.length > 0 && (
            <div>
              <h3>Itinerário de Cidades</h3>
              {formData.itinerioCidades.map((cidade, index) => (
                <div key={index}>
                  {cidade && (
                    <span
                      style={{
                        fontSize: "0.9em",
                        color: "#555",
                        paddingLeft: "10px",
                      }}
                    >
                      {cidade.length} / 20
                    </span>
                  )}
                  <InputField
                    errors={errors}
                    type="text"
                    name={`cidade-${index}`}
                    value={cidade}
                    onChange={(e) =>
                      handleInputChange(e, index, "itinerioCidades")
                    }
                    placeholder={`Cidade ${index + 1}`}
                    maxLength={20}
                  />
                  {formData.itinerioCidades.length > 1 && (
                    <button
                      type="button"
                      style={{
                        color: " red",
                        backgroundColor: "#ffffff00",
                        marginBottom: "20px",
                        padding: "5px",
                        border: "solid 1px  red",
                        borderRadius: "20px",
                      }}
                      onClick={() => removeEntry("itinerioCidades", index)}
                    >
                      - Remover
                    </button>
                  )}
                </div>
              ))}
              <button type="button" onClick={() => addEntry("itinerioCidades")}>
                + Adicionar Cidade
              </button>
            </div>
          )}
          {/* Deixe esta div em branco para viagens específicas */}
        </div>
      )}

      <h1 style={{ fontSize: "1rem" }}>Endereço onde você ficará nos EUA</h1>
      <div className={styles.obsForm}>
        <p>Se não souber deixe em branco que incluímos.</p>
      </div>
      <div>
        <label>
          Endereço de onde se hospedará:
          {formData.hospedagem && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.hospedagem.length} / 40
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="hospedagem"
          value={formData.hospedagem}
          onChange={handleInputChange}
          maxLength={400}
        />
      </div>
      <div>
        <label
          style={{
            fontWeight: viagemNao ? "bold" : "normal",
          }}
        >
          Cidade pretendida:
          {formData.cidadePretendida && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.cidadePretendida.length} / 20
            </span>
          )}
        </label>

        <InputField
          errors={errors}
          type="text"
          name="cidadePretendida"
          value={formData.cidadePretendida}
          onChange={handleInputChange}
          maxLength={20}
          style={{
            border: viagemNao ? "2px solid #1f3a8a" : undefined,
            fontWeight: viagemNao ? "bold" : "normal",
          }}
        />
      </div>
      <div>
        <label>Estado pretendido:</label>
        <select
          name="estadoPretendido"
          value={formData.estadoPretendido}
          onChange={handleInputChange}
        >
          {estados.map((estado) => (
            <option key={estado.value} value={estado.value}>
              {estado.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label>ZIP Code:</label>
        <InputField
          errors={errors}
          type="text"
          name="zipcode"
          value={formData.zipcode}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <div>
          <label>Quem vai pagar a sua viagem?</label>
        </div>

        <select
          style={{ width: "auto" }}
          type="select"
          name="custeador"
          value={formData.custeador}
          // checked={formData.custeador === 'euMesmo' || formData.custeador === 'S'}
          onChange={handleInputChange}
        >
          <option value="">- Selecione uma opção -</option>
          <option value="S">Eu Mesmo</option>
          <option value="O">Outra Pessoa</option>
          <option value="P" tooltip="">
            Empregador Atual
          </option>
          <option value="U" tooltip="">
            Empregador nos EUA
          </option>
          <option selected="selected" value="C">
            Outra Empresa/Organização
          </option>
        </select>

        {(formData.custeador === "outraPessoa" ||
          formData.custeador === "O" ||
          formData.custeador === "C") && (
          <div>
            <label>
              Nome (sponsor):
              {formData.sponsorNome && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.sponsorNome.length} / 33
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="text"
              name="sponsorNome"
              value={formData.sponsorNome}
              onChange={handleInputChange}
              maxLength={33}
            />
            <label>
              Sobrenome (sponsor):
              {formData.sponsorSobreNome && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.sponsorSobreNome.length} / 33
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="text"
              name="sponsorSobreNome"
              value={formData.sponsorSobreNome}
              onChange={handleInputChange}
              maxLength={33}
            />
            <label>
              Telefone s (sponsor):
              {formData.sponsorTelefone && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.sponsorTelefone.length} / 15
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="text"
              name="sponsorTelefone"
              value={formData.sponsorTelefone}
              onChange={(e) => sanitizeNumberInput(e, handleInputChange)}
              maxLength={15}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="Digite apenas números"
            />

            <label>
              E-mail (sponsor):
              {formData.sponsorEmail && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.sponsorEmail.length} / 50
                </span>
              )}
            </label>
            <InputField
              errors={errors}
              type="email"
              name="sponsorEmail"
              value={formData.sponsorEmail}
              onChange={handleInputChange}
              style={{
                border: errors.sponsorEmail ? "1px solid red" : undefined,
              }}
              maxLength={50}
            />
            <label>Grau de parentesco com o solicitante:</label>
            <InputField
              errors={errors}
              type="text"
              name="sponsorParentesco"
              value={formData.sponsorParentesco}
              onChange={handleInputChange}
            />
            <label>Endereço com CEP (sponsor):</label>
            <InputField
              errors={errors}
              type="text"
              name="sponsorEndereco"
              value={formData.sponsorEndereco}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
      <h1 style={{ fontSize: "1rem" }}>Acompanhantes de viagem</h1>
      <div>
        <div className={styles.obsForm}>
          <p>
            São Pessoas que vão viajar junto com você para os Estados Unidos.
            (Informe nome COMPLETO e Grau de Parentesco)
          </p>
        </div>
        {formData.acompanhantes.map((acompanhante, index) => (
          <div key={index}>
            {acompanhante.nome && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {acompanhante.nome.length} / 33
              </span>
            )}
            <div>
              <InputField
                errors={errors}
                type="text"
                name={`acompanhanteNome-${index}`}
                value={acompanhante.nome}
                onChange={(e) =>
                  handleInputChange(e, index, "acompanhantes", "nome")
                }
                placeholder={`Nome do acompanhante ${index + 1}`}
                maxLength={33}
              />
            </div>

            {acompanhante.sobrenome && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {acompanhante.sobrenome.length} / 33
              </span>
            )}

            <div>
              <InputField
                errors={errors}
                type="text"
                name={`acompanhanteSobreNome-${index}`}
                value={acompanhante.sobrenome}
                onChange={(e) =>
                  handleInputChange(e, index, "acompanhantes", "sobrenome")
                }
                placeholder={`sobrenome do acompanhante ${index + 1}`}
                maxLength={33}
              />
            </div>

            <select
              name={`acompanhanteParentesco-${index}`}
              value={acompanhante.parentesco}
              onChange={(e) =>
                handleInputChange(e, index, "acompanhantes", "parentesco")
              }
            >
              <option value="">Parentesco</option>
              <option value="P">PAIS</option>
              <option value="S">MARIDO/ESPOSA</option>
              <option value="C">FILHOS</option>
              <option value="R">OUTRO FAMILIAR</option>
              <option value="F">AMIGO</option>
              <option value="B">BUSINESS ASSOCIATE</option>
              <option value="O">OUTROS</option>
            </select>

            <div>
              <button
                type="button"
                style={{
                  color: " red",
                  backgroundColor: "#ffffff00",
                  marginBottom: "20px",
                  padding: "5px",
                  border: "solid 1px  red",
                  borderRadius: "20px",
                }}
                onClick={() => removeEntry("acompanhantes", index)}
              >
                - Remover
              </button>
            </div>
          </div>
        ))}
        {formData.acompanhantes.length < 10 && (
          <button type="button" onClick={() => addEntry("acompanhantes")}>
            + Adicionar Acompanhante
          </button>
        )}
      </div>
    </div>
  );
}

// Função que renderiza a etapa de Residência e Vistos nos EUA
export function ResidenciaEVistosEUA({
  formData,
  handleInputChange,
  addEntry,
  removeEntry,
  errors,
  setFormField,
  tipo,
}) {
  return (
    <div>
      <h2>Residência e Vistos nos EUA</h2>
      <div>
        <label>Você possui Nº do Social Security?</label>
        <div>
          <div>
            <InputField
              errors={errors}
              type="radio"
              style={{ width: "auto" }}
              name="possuiSocialSecurity"
              value="nao"
              checked={formData.possuiSocialSecurity === "nao"}
              onChange={handleInputChange}
            />
            <label>Não</label>
          </div>
          <div>
            <InputField
              errors={errors}
              type="radio"
              style={{ width: "auto" }}
              name="possuiSocialSecurity"
              value="sim"
              checked={formData.possuiSocialSecurity === "sim"}
              onChange={handleInputChange}
            />
            <label>Sim</label>
          </div>
          {formData.possuiSocialSecurity === "sim" && (
            <div>
              <label>Nº do Social Security:</label>
              <InputField
                errors={errors}
                type="text"
                name="socialSecurity"
                value={formData.socialSecurity}
                onChange={handleInputChange}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <label>Você possui Nº de identificação fiscal nos EUA?</label>
        <div>
          <div>
            <InputField
              errors={errors}
              type="radio"
              style={{ width: "auto" }}
              name="possuiIdFiscalEUA"
              value="nao"
              checked={formData.possuiIdFiscalEUA === "nao"}
              onChange={handleInputChange}
            />
            <label>Não</label>
          </div>
          <div>
            <InputField
              errors={errors}
              type="radio"
              style={{ width: "auto" }}
              name="possuiIdFiscalEUA"
              value="sim"
              checked={formData.possuiIdFiscalEUA === "sim"}
              onChange={handleInputChange}
            />
            <label>Sim</label>
          </div>
          {formData.possuiIdFiscalEUA === "sim" && (
            <div>
              <label>Nº de identificação fiscal nos EUA:</label>
              <InputField
                errors={errors}
                type="text"
                name="idFiscalEUA"
                value={formData.idFiscalEUA}
                onChange={handleInputChange}
              />
            </div>
          )}
        </div>
      </div>
      {/* "Você já esteve nos EUA?" permite até 10 entradas */}
      <div>
        <label>Você já esteve nos EUA?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="esteveEUA"
            value="nao"
            checked={formData.esteveEUA === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="esteveEUA"
            value="sim"
            checked={formData.esteveEUA === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.esteveEUA === "sim" && (
          <div>
            <div className={styles.obsForm}>
              <p>
                Para saber seu histórico de viagens aos Estados Unidos nos
                ultimos 10 anos, acesse no seu navegador
                <a
                  href="https://i94.cbp.dhs.gov/I94/#/home"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://i94.cbp.dhs.gov/I94/#/home
                </a>
                , em Ver Histórico de Viagens, realize pesquisa com os dados do
                seu passaporte ANTERIORES e ATUAL.
              </p>
            </div>

            {formData.viagensEUA?.map((viagem, index) => (
              <div key={index}>
                <label>Data de entrada:</label>
                <InputField
                  errors={errors}
                  type="date"
                  name={`dataEntradaEUA-${index}`}
                  value={viagem.dataEntrada}
                  onChange={(e) =>
                    handleInputChange(e, index, "viagensEUA", "dataEntrada")
                  }
                />
                <label>Duração: (EM DIAS)</label>
                <InputField
                  errors={errors}
                  type="text"
                  name={`duracaoEUA-${index}`}
                  value={viagem.duracao}
                  onChange={(e) =>
                    handleInputChange(e, index, "viagensEUA", "duracao")
                  }
                />
                <button
                  type="button"
                  style={{
                    color: " red",
                    backgroundColor: "#ffffff00",
                    marginBottom: "20px",
                    padding: "5px",
                    border: "solid 1px  red",
                    borderRadius: "20px",
                  }}
                  onClick={() => removeEntry("viagensEUA", index)}
                >
                  - Remover Viagem
                </button>
              </div>
            ))}
            {formData.viagensEUA?.length < 10 && (
              <button type="button" onClick={() => addEntry("viagensEUA")}>
                + Adicionar Viagem
              </button>
            )}
          </div>
        )}
      </div>
      {/* Carteira de Habilitação */}
      {!tipo || tipo !== "kid" ? (
        <div>
          <label>Você possui carteira de habilitação americana?</label>
          <div>
            <InputField
              errors={errors}
              type="radio"
              style={{ width: "auto" }}
              name="carteiraHabilitacao"
              value="nao"
              checked={formData.carteiraHabilitacao === "nao"}
              onChange={handleInputChange}
            />
            <label>Não</label>
            <InputField
              errors={errors}
              type="radio"
              style={{ width: "auto" }}
              name="carteiraHabilitacao"
              value="sim"
              checked={formData.carteiraHabilitacao === "sim"}
              onChange={handleInputChange}
            />
            <label>Sim</label>
          </div>
          {formData.carteiraHabilitacao === "sim" && (
            <div>
              <label>Validade:</label>
              <InputField
                errors={errors}
                type="date"
                name="validadeHabilitacao"
                value={formData.validadeHabilitacao}
                onChange={handleInputChange}
              />
              <label>Estado de emissão:</label>
              <InputField
                errors={errors}
                type="text"
                name="estadoEmissaoHabilitacao"
                value={formData.estadoEmissaoHabilitacao}
                onChange={handleInputChange}
              />
            </div>
          )}
        </div>
      ) : null}
      <div>
        <label>Você já teve um visto americano?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="teveVisto"
            value="nao"
            checked={formData.teveVisto === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="teveVisto"
            value="sim"
            checked={formData.teveVisto === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.teveVisto === "sim" && (
          <div>
            <h3>Detalhes do Último Visto</h3>
            <label>Número do último visto: (Número em vermelho)</label>
            <InputField
              errors={errors}
              type="text"
              name="ultimoVistoNumero"
              value={formData.ultimoVistoNumero}
              onChange={handleInputChange}
            />
            <div>
              <label>Categoria do visto:</label>

              <select
                type="select"
                name="ultimoVistoCategoria"
                value={formData.ultimoVistoCategoria}
                onChange={handleInputChange}
              >
                <option value="">Selecione uma Categoria</option>
                <option value="B">TURISMO (B1/B2)</option>
                <option value="F">ACADEMIC OR LANGUAGE STUDENT (F)</option>
                <option value="M">VOCATIONAL/NONACADEMIC STUDENT (M)</option>
                <option value="N">OUTRA CATEGORIA (N)</option>
                <option value="A">FOREIGN GOVERNMENT OFFICIAL (A)</option>
                <option value="C">ALIEN IN TRANSIT (C)</option>
                <option value="CNMI">CNMI WORKER OR INVESTOR (CW/E2C)</option>
                <option value="D">CREWMEMBER (D)</option>
                <option value="E">TREATY TRADER OR INVESTOR (E)</option>
                <option value="G">
                  INTERNATIONAL ORGANIZATION REP./EMP. (G)
                </option>
                <option value="H">TEMPORARY WORKER (H)</option>
                <option value="I">FOREIGN MEDIA REPRESENTATIVE (I)</option>
                <option value="J">EXCHANGE VISITOR (J)</option>
                <option value="K">
                  FIANCÉ(E) OR SPOUSE OF A U.S. CITIZEN (K)
                </option>
                <option value="L">INTRACOMPANY TRANSFEREE (L)</option>
                <option value="NATO">NATO STAFF (NATO)</option>
                <option value="O">ALIEN WITH EXTRAORDINARY ABILITY (O)</option>
                <option value="P">INTERNATIONALLY RECOGNIZED ALIEN (P)</option>
                <option value="Q">CULTURAL EXCHANGE VISITOR (Q)</option>
                <option value="R">RELIGIOUS WORKER (R)</option>
                <option value="S">INFORMANT OR WITNESS (S)</option>
                <option value="T">VICTIM OF TRAFFICKING (T)</option>
                <option value="TD/TN">NAFTA PROFESSIONAL (TD/TN)</option>
                <option value="U">VICTIM OF CRIMINAL ACTIVITY (U)</option>
                <option value="PAROLE-BEN">PAROLE BENEFICIARY (PARCIS)</option>
              </select>
            </div>

            <label>Data de emissão:</label>
            <InputField
              errors={errors}
              type="date"
              name="ultimoVistoDataEmissao"
              value={formData.ultimoVistoDataEmissao}
              onChange={handleInputChange}
            />
            <label>Data de vencimento:</label>
            <InputField
              errors={errors}
              type="date"
              name="ultimoVistoDataExpiracao"
              value={formData.ultimoVistoDataExpiracao}
              onChange={handleInputChange}
            />

            <label>Você já teve carteira de habilitação americana?</label>
            <div>
              <InputField
                errors={errors}
                style={{ width: "auto" }}
                type="radio"
                name="carteiradeHabilitacao"
                value="nao"
                checked={formData.carteiradeHabilitacao === "nao"}
                onChange={handleInputChange}
              />
              <label>Não</label>
            </div>
            <div>
              <InputField
                errors={errors}
                style={{ width: "auto" }}
                type="radio"
                name="carteiradeHabilitacao"
                value="sim"
                checked={formData.carteiradeHabilitacao === "sim"}
                onChange={handleInputChange}
              />
              <label>Sim</label>
            </div>
            {/* <label>Por favor, envie uma cópia do visto anterior:</label>
                        <InputField
errors={errors}
                            type="file"
                            name="copiaVistoAnterior"
                            onChange={handleInputChange}
                        /> */}
          </div>
        )}
      </div>
      <div>
        <label>Você já teve algum visto americano roubado ou perdido?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="vistoRoubadoPerdido"
            value="nao"
            checked={formData.vistoRoubadoPerdido === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="vistoRoubadoPerdido"
            value="sim"
            checked={formData.vistoRoubadoPerdido === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.vistoRoubadoPerdido === "sim" && (
          <div>
            <label>Explique, fez boletin de ocorrência?:</label>
            <textarea
              className={styles.textareaForm}
              name="detalhesVistoRoubadoPerdido"
              value={formData.detalhesVistoRoubadoPerdido}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
      <div>
        <label>Você já teve algum visto EUA cancelado ou revogado?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="vistoCancelado"
            value="nao"
            checked={formData.vistoCancelado === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="vistoCancelado"
            value="sim"
            checked={formData.vistoCancelado === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.vistoCancelado === "sim" && (
          <div>
            <label>Onde, quando e tipo de visto cancelado:</label>
            <textarea
              className={styles.textareaForm}
              name="detalhesVistoCancelado"
              value={formData.detalhesVistoCancelado}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
      <div>
        <label>Você já teve algum visto EUA NEGADO?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="vistoNegado"
            value="nao"
            checked={formData.vistoNegado === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="vistoNegado"
            value="sim"
            checked={formData.vistoNegado === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.vistoNegado === "sim" && (
          <div>
            <label>
              Onde, quando e tipo de visto:
              {formData.detalhesVistoNegado && (
                <span
                  style={{
                    fontSize: "0.9em",
                    color: "#555",
                    paddingLeft: "10px",
                  }}
                >
                  {formData.detalhesVistoNegado.length} / 4000
                </span>
              )}
            </label>
            <textarea
              className={styles.textareaForm}
              name="detalhesVistoNegado"
              value={formData.detalhesVistoNegado}
              onChange={handleInputChange}
              maxLength={4000}
            />
          </div>
        )}
      </div>
      <div>
        <label>
          Você já entrou com uma petição de imigração para obtenção de cidadania
          nos EUA?
        </label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="peticaoImigracao"
            value="nao"
            checked={formData.peticaoImigracao === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="peticaoImigracao"
            value="sim"
            checked={formData.peticaoImigracao === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.peticaoImigracao === "sim" && (
          <div>
            <label>Explique detalhes:</label>
            <textarea
              className={styles.textareaForm}
              name="detalhesPeticaoImigracao"
              value={formData.detalhesPeticaoImigracao}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// Função que renderiza a etapa de Ocupação Atual
export function OcupacaoAtual({
  formData,
  handleInputChange,
  errors,
  addEntry,
  removeEntry,
}) {
  return (
    <div>
      <h2>Ocupação Atual</h2>
      <select
        type="text"
        name="ocupacaoAtualSelect"
        value={formData.ocupacaoAtualSelect}
        onChange={handleInputChange}
      >
        <option value="">Selecione uma Categoria</option>
        <option value="A">Agricultura</option>
        <option value="AP">Artista/Intérprete</option>
        <option value="B">Negócios</option>
        <option value="CM">Comunicações</option>
        <option value="CS">Ciência da Computação</option>
        <option value="C">Culinária/Serviços de Alimentação</option>
        <option value="ED">Educação</option>
        <option value="EN">Engenharia</option>
        <option value="G">Governo</option>
        <option value="H">Dona de Casa</option>
        <option value="LP">Profissão Jurídica</option>
        <option value="MH">Médico/Serviços de Saúde</option>
        <option value="M">Militar</option>
        <option value="NS">Ciências Naturais</option>
        <option value="N">Não Empregado</option>
        <option value="PS">Ciências Físicas</option>
        <option value="RV">Vocação Religiosa</option>
        <option value="R">Pesquisa</option>
        <option value="RT">Aposentado</option>
        <option value="SS">Ciências Sociais</option>
        <option value="S">Estudante</option>
        <option value="O">Outro</option>
      </select>

      <div>
        <label>Ocupação Atual (Cargo):</label>
        <InputField
          errors={errors}
          type="text"
          name="ocupacaoAtual"
          value={formData.ocupacaoAtual}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Se desempregado, explique:</label>
        <textarea
          className={styles.textareaForm}
          name="explicacaoDesempregado"
          value={formData.explicacaoDesempregado}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Nome da Empresa:</label>
        {formData.empresa && (
          <span
            style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
          >
            {formData.empresa.length} / 75
          </span>
        )}
        <InputField
          errors={errors}
          type="text"
          name="empresa"
          value={formData.empresa}
          onChange={handleInputChange}
          maxLength={75}
        />
      </div>
      <div>
        <label>Data de Início:</label>
        <InputField
          errors={errors}
          type="date"
          name="dataInicio"
          value={formData.dataInicio}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>
          Endereço:
          {formData.enderecoEmpresa && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.enderecoEmpresa.length} / 40
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="enderecoEmpresa"
          value={formData.enderecoEmpresa}
          onChange={handleInputChange}
          maxLength={40}
        />
      </div>
      <div>
        <label>
          Bairro:
          {formData.bairroEmpresa && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.bairroEmpresa.length} / 40
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="bairroEmpresa"
          value={formData.bairroEmpresa}
          onChange={handleInputChange}
          maxLength={40}
        />
      </div>
      <div>
        <label>
          Cidade:
          {formData.cidadeEmpresa && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.cidadeEmpresa.length} / 20
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="cidadeEmpresa"
          value={formData.cidadeEmpresa}
          onChange={handleInputChange}
          maxLength={20}
        />
      </div>
      <div>
        <div>
          <label>Estado:</label>
        </div>
        <select
          name="estadoEmpresa"
          value={formData.estadoEmpresa}
          onChange={handleInputChange}
        >
          <option value="">- Selecione um estado -</option>
          {estadosBrasileiros.map((estado) => (
            <option key={estado.value} value={estado.value}>
              {estado.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <div>
          <label>CEP:</label>
        </div>
        <InputField
          errors={errors}
          type="number"
          name="cepEmpresa"
          value={formData.cepEmpresa}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Telefone:</label>
        {formData.telefoneEmpresa && (
          <span
            style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
          >
            {formData.telefoneEmpresa.length} / 15
          </span>
        )}
        <InputField
          errors={errors}
          type="text"
          name="telefoneEmpresa"
          value={formData.telefoneEmpresa}
          onChange={(e) => sanitizeNumberInput(e, handleInputChange)}
          maxLength={15}
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="Digite apenas números"
        />
      </div>
      <div>
        <label>
          Média da Renda Mensal Líquida:
          <span
            style={{
              display: "block",
              fontSize: "0.9em",
              color: "#888",
              marginTop: "2px",
            }}
          >
            Digite apenas o valor inteiro, sem centavos.
          </span>
        </label>
        <div style={{ position: "relative", display: "inline-block" }}>
          <InputField
            errors={errors}
            // type="text"
            name="rendaMensal"
            value={formData.rendaMensal}
            onChange={(e) => sanitizeNumberInput(e, handleInputChange)}
            placeholder="Ex: 2500"
            inputMode="numeric"
            pattern="[0-9]*"
          />
          <span
            style={{
              position: "absolute",
              right: "-10px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#777",
              pointerEvents: "none",
              fontSize: "1.0rem",
            }}
          >
            ,00 R$
          </span>
        </div>
      </div>
      {/* <div>
                <label>Função:</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="funcao"
                    value={formData.funcao}
                    onChange={handleInputChange}
                />
            </div> */}
      <div>
        <label>Breve Explicação da Função:</label>
        {formData.explicacaoFuncao && (
          <span
            style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
          >
            {formData.explicacaoFuncao.length} / 4000
          </span>
        )}
        <textarea
          className={styles.textareaForm}
          name="explicacaoFuncao"
          value={formData.explicacaoFuncao}
          onChange={handleInputChange}
          maxLength={4000}
        />
      </div>
      <div>
        <label>Trabalho autônomo ou possui Empresa?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="trabalhoAutonomoOuEmpresa"
            value="nao"
            checked={formData.trabalhoAutonomoOuEmpresa === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="trabalhoAutonomoOuEmpresa"
            value="sim"
            checked={formData.trabalhoAutonomoOuEmpresa === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.trabalhoAutonomoOuEmpresa === "sim" && (
          <div>
            <label>Informe MEI ou CNPJ:</label>
            <InputField
              errors={errors}
              type="text"
              name="meiCnpj"
              value={formData.meiCnpj}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// Componente para a seção de Formações Acadêmicas
export function FormacoesAcademicas({
  formData,
  handleInputChange,
  errors,
  addEntry,
  removeEntry,
}) {
  return (
    <div>
      <div>
        <h2>Ocupações Anteriores</h2>
        <div className={styles.obsForm}>
          <p>Informe seus últimos trabalhos de até 5 anos atrás.</p>
        </div>
        {formData.ocupacaoAnterior.map((ocupacao, index) => (
          <div key={index}>
            <h3>Ocupação {index + 1}</h3>
            <label>Nome da Empresa:</label>
            {ocupacao.empresa && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {ocupacao.empresa.length} / 75
              </span>
            )}
            <InputField
              errors={errors}
              type="text"
              name={`empresa-${index}`}
              value={ocupacao.empresa}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "empresa")
              }
              maxLength={75}
            />
            <label>Endereço:</label>
            {ocupacao.endereco && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {ocupacao.endereco.length} / 40
              </span>
            )}
            <InputField
              errors={errors}
              type="text"
              name={`endereco-${index}`}
              value={ocupacao.endereco}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "endereco")
              }
              maxLength={40}
            />
            <label>Bairro:</label>
            {ocupacao.bairro && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {ocupacao.bairro.length} / 40
              </span>
            )}
            <InputField
              errors={errors}
              type="text"
              name={`bairro-${index}`}
              value={ocupacao.bairro}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "bairro")
              }
              maxLength={40}
            />
            <label>Cidade:</label>
            {ocupacao.cidade && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {ocupacao.cidade.length} / 20
              </span>
            )}
            <InputField
              errors={errors}
              type="text"
              name={`cidade-${index}`}
              value={ocupacao.cidade}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "cidade")
              }
              maxLength={20}
            />
            <div>
              <div>
                <label>Estado:</label>
              </div>
              <select
                name={`estado-${index}`}
                value={ocupacao.estado}
                onChange={(e) =>
                  handleInputChange(e, index, "ocupacaoAnterior", "estado")
                }
              >
                <option value="">- Selecione um estado -</option>
                {estadosBrasileiros.map((estado) => (
                  <option key={estado.value} value={estado.value}>
                    {estado.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label>CEP:</label>
            </div>
            <InputField
              errors={errors}
              type="text"
              name={`cep-${index}`}
              value={ocupacao.cep}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "cep")
              }
            />
            <label>Telefone:</label>
            {ocupacao.telefone && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {ocupacao.telefone.length} / 15
              </span>
            )}
            <InputField
              errors={errors}
              type="text"
              name={`telefone-${index}`}
              value={ocupacao.telefone}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/\D/g, "");
                handleInputChange(
                  {
                    target: {
                      name: e.target.name,
                      value: onlyNumbers,
                    },
                  },
                  index,
                  "ocupacaoAnterior",
                  "telefone",
                );
              }}
              maxLength={15}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="Digite apenas números"
            />

            <label>Cargo:</label>
            <InputField
              errors={errors}
              type="text"
              name={`cargo-${index}`}
              value={ocupacao.cargo}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "cargo")
              }
            />
            <label>Data de Admissão:</label>
            <InputField
              errors={errors}
              type="date"
              name={`dataAdmissao-${index}`}
              value={ocupacao.dataAdmissao}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "dataAdmissao")
              }
            />
            <label>Data de Demissão:</label>
            <InputField
              errors={errors}
              type="date"
              name={`dataDemissao-${index}`}
              value={ocupacao.dataDemissao}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "dataDemissao")
              }
              disabled={ocupacao.aindaEmpregado}
              style={{
                backgroundColor: ocupacao.aindaEmpregado ? "#A9A9A9" : "white",
              }}
            />
            <div>
              <InputField
                errors={errors}
                type="checkbox"
                style={{ width: "auto", marginRight: "5px" }}
                name={`aindaEmpregado-${index}`}
                checked={ocupacao.aindaEmpregado}
                onChange={(e) =>
                  handleInputChange(
                    e,
                    index,
                    "ocupacaoAnterior",
                    "aindaEmpregado",
                  )
                }
              />
              Ainda Empregado
            </div>
            <label>Descrição das Funções:</label>
            {ocupacao.descricao && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {ocupacao.descricao.length} / 4000
              </span>
            )}
            <textarea
              className={styles.textareaForm}
              name={`descricao-${index}`}
              value={ocupacao.descricao}
              onChange={(e) =>
                handleInputChange(e, index, "ocupacaoAnterior", "descricao")
              }
              maxLength={4000}
            />
            <button
              type="button"
              style={{
                color: " red",
                backgroundColor: "#ffffff00",
                marginBottom: "20px",
                padding: "5px",
                border: "solid 1px  red",
                borderRadius: "20px",
              }}
              onClick={() => removeEntry("ocupacaoAnterior", index)}
            >
              - Remover Ocupação
            </button>
          </div>
        ))}
        {formData.ocupacaoAnterior.length < 3 && (
          <div>
            <button type="button" onClick={() => addEntry("ocupacaoAnterior")}>
              + Adicionar Ocupação
            </button>
            <div>{/* <p>Até 2 ocupações anteriores.</p> */}</div>
          </div>
        )}
      </div>
      <h2>Formações Acadêmicas</h2>
      <div className={styles.obsForm}>
        <div>
          <label>
            (Ensino Superior, Curso técnico/profissionalizante, Ensino Médio)
          </label>
        </div>
        <div>
          <label>mesmo que não tenha concluído.</label>
        </div>
      </div>

      {formData.formacaoAcademica.map((formacao, index) => (
        <div key={index}>
          <h3>Formação {index + 1}</h3>
          <label>Nome da Instituição:</label>
          {formacao.instituicao && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formacao.instituicao.length} / 75
            </span>
          )}
          <InputField
            errors={errors}
            type="text"
            name={`instituicao-${index}`}
            value={formacao.instituicao}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "instituicao")
            }
            maxLength={75}
          />
          <label>Endereço:</label>
          {formacao.endereco && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formacao.endereco.length} / 40
            </span>
          )}
          <InputField
            errors={errors}
            type="text"
            name={`endereco-${index}`}
            value={formacao.endereco}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "endereco")
            }
            maxLength={40}
          />
          <label>Bairro:</label>
          {formacao.bairro && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formacao.bairro.length} / 40
            </span>
          )}
          <InputField
            errors={errors}
            type="text"
            name={`bairro-${index}`}
            value={formacao.bairro}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "bairro")
            }
            maxLength={40}
          />
          <label>Cidade:</label>
          {formacao.cidade && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formacao.cidade.length} / 20
            </span>
          )}
          <InputField
            errors={errors}
            type="text"
            name={`cidade-${index}`}
            value={formacao.cidade}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "cidade")
            }
            maxLength={20}
          />
          <div>
            <div>
              <label>Estado:</label>
            </div>
            <select
              name={`estado-${index}`}
              value={formacao.estado}
              onChange={(e) =>
                handleInputChange(e, index, "formacaoAcademica", "estado")
              }
            >
              <option value="">- Selecione um estado -</option>
              {estadosBrasileiros.map((estado) => (
                <option key={estado.value} value={estado.value}>
                  {estado.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>CEP:</label>
          </div>
          <InputField
            errors={errors}
            type="text"
            name={`cep-${index}`}
            value={formacao.cep}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "cep")
            }
          />
          <label>Curso de Estudo:</label>
          {formacao.curso && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formacao.curso.length} / 66
            </span>
          )}
          <InputField
            errors={errors}
            type="text"
            name={`curso-${index}`}
            value={formacao.curso}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "curso")
            }
            maxLength={66}
          />
          <label>Data de Início:</label>
          <InputField
            errors={errors}
            type="date"
            name={`dataInicio-${index}`}
            value={formacao.dataInicio}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "dataInicio")
            }
          />
          <label>Data de Término:</label>
          <InputField
            errors={errors}
            type="date"
            name={`dataTermino-${index}`}
            value={formacao.dataTermino}
            onChange={(e) =>
              handleInputChange(e, index, "formacaoAcademica", "dataTermino")
            }
            disabled={formacao.aindaEstudando}
            style={{
              backgroundColor: formacao.aindaEstudando ? "#A9A9A9" : "white",
            }}
          />
          <div>
            <InputField
              errors={errors}
              type="checkbox"
              style={{ width: "auto", marginRight: "5px" }}
              name={`aindaEstudando-${index}`}
              checked={formacao.aindaEstudando}
              onChange={(e) =>
                handleInputChange(
                  e,
                  index,
                  "formacaoAcademica",
                  "aindaEstudando",
                )
              }
            />
            Ainda Estudando
          </div>
          <button
            type="button"
            style={{
              color: " red",
              backgroundColor: "#ffffff00",
              marginBottom: "20px",
              padding: "5px",
              border: "solid 1px  red",
              borderRadius: "20px",
            }}
            onClick={() => removeEntry("formacaoAcademica", index)}
          >
            - Remover Formação
          </button>
        </div>
      ))}
      {formData.formacaoAcademica.length < 5 && (
        <button type="button" onClick={() => addEntry("formacaoAcademica")}>
          + Adicionar Formação
        </button>
      )}
    </div>
  );
}

// Função que renderiza a etapa de Endereço e Contato
export function EnderecoEContato({
  formData,
  handleInputChange,
  addEntry,
  removeEntry,
  errors,
}) {
  // Prefixos por plataforma
  const SOCIAL_PREFIX = {
    SONE: "",
    INST: "https://instagram.com/",
    FCBK: "https://facebook.com/",
    LINK: "https://linkedin.com/in/",
    TWIT: "https://twitter.com/",
    YTUB: "https://youtube.com/@",
    TKTK: "https://tiktok.com/@",
    OUTR: "https://",
    SITE: "https://",
    ASKF: "https://ask.fm/",
    DUBN: "https://www.douban.com/people/",
    FLKR: "https://flickr.com/people/",
    GOGL: "https://plus.google.com/", // legado
    MYSP: "https://myspace.com/",
    PTST: "https://pinterest.com/",
    QZNE: "https://qzone.qq.com/",
    RDDT: "https://reddit.com/user/",
    SWBO: "https://weibo.com/",
    TWBO: "https://t.qq.com/", // legado
    TUMB: "https://tumblr.com/",
    TWOO: "https://twoo.com/",
    VINE: "https://vine.co/", // legado
    VKON: "https://vk.com/",
    YUKU: "https://youku.com/",
    NONE: "",
  };

  function buildSocialUrl(prefix, rawUser) {
    const p = prefix || "";

    // normaliza o que o usuário digitou/colou
    let user = (rawUser || "").trim();

    // Se o prefixo termina com "@", remove arrobas repetidas no início do username
    const endsWithAt = p.endsWith("@");
    if (endsWithAt) {
      user = user.replace(/^@+/, "");
    }

    // Para prefixos com "/" (a maioria), remova barras extras no início do username
    if (!endsWithAt) {
      user = user.replace(/^\/+/, "");
    }

    // CASO ESPECIAL: prefixo genérico "https://"
    // - remove qualquer http(s):// do que o usuário digitou
    // - remove barras duplas
    if (p === "https://") {
      user = user.replace(/^https?:\/\//i, ""); // remove protocolo
      user = user.replace(/^\/+/, ""); // remove barras iniciais
      user = user.replace(/\/{2,}/g, "/"); // colapsa barras repetidas
      return p + user;
    }

    // Regra geral: evita duplicar o prefixo se o usuário colou a URL completa
    if (user.toLowerCase().startsWith(p.toLowerCase())) {
      user = user.slice(p.length);
      user = user.replace(/^[@/]+/, "");
    }

    // Garante que o prefixo que termina em "/" fique com apenas uma "/"
    let safePrefix = p;
    if (!endsWithAt) {
      safePrefix = p.replace(/\/+$/, "/");
    }

    return safePrefix + user;
  }

  function extractUsernameFromFull(prefix, full) {
    if (!full) return "";
    let s = full.trim();

    // Para prefixo genérico, remova http(s):// primeiro
    if ((prefix || "") === "https://") {
      s = s.replace(/^https?:\/\//i, "");
    }

    // Remove o prefixo específico (se presente)
    if (prefix) {
      s = s.replace(
        new RegExp("^" + prefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"),
        "",
      );
    }

    // Limpa @ ou / iniciais duplicados
    s = s.replace(/^[@/]+/, "");

    return s;
  }

  // (opcional) se quiser mostrar prevUrl em cada option
  const socialMediaOptions = [
    { value: "SONE", label: "- Select One -" },
    { value: "INST", label: "INSTAGRAM" },
    { value: "FCBK", label: "FACEBOOK" },
    { value: "LINK", label: "LINKEDIN" },
    { value: "TWIT", label: "TWITTER (X)" },
    { value: "YTUB", label: "YOUTUBE" },
    { value: "TKTK", label: "TIKTOK" },
    { value: "OUTR", label: "OUTRA" },
    { value: "SITE", label: "SITE PROPRIO" },
    { value: "ASKF", label: "ASK.FM" },
    { value: "DUBN", label: "DOUBAN" },
    { value: "FLKR", label: "FLICKR" },
    { value: "GOGL", label: "GOOGLE+" },
    { value: "MYSP", label: "MYSPACE" },
    { value: "PTST", label: "PINTEREST" },
    { value: "QZNE", label: "QZONE (QQ)" },
    { value: "RDDT", label: "REDDIT" },
    { value: "SWBO", label: "SINA WEIBO" },
    { value: "TWBO", label: "TENCENT WEIBO" },
    { value: "TUMB", label: "TUMBLR" },
    { value: "TWOO", label: "TWOO" },
    { value: "VINE", label: "VINE" },
    { value: "VKON", label: "VKONTAKTE (VK)" },
    { value: "YUKU", label: "YOUKU" },
    { value: "NONE", label: "NONE" },
  ];

  return (
    <div>
      <h2>Endereço e Contato</h2>
      <div>
        <label>
          Endereço:
          {formData.endereco && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.endereco.length} / 39
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="endereco"
          value={formData.endereco}
          onChange={handleInputChange}
          maxLength={39}
        />
      </div>
      <div>
        <label>
          Bairro:
          {formData.bairro && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.bairro.length} / 20
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="bairro"
          value={formData.bairro}
          onChange={handleInputChange}
          maxLength={40}
        />
      </div>
      <div>
        <label>
          Cidade:
          {formData.cidadeEstado && (
            <span
              style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}
            >
              {formData.cidadeEstado.length} / 20
            </span>
          )}
        </label>
        <InputField
          errors={errors}
          type="text"
          name="cidadeEstado"
          value={formData.cidadeEstado}
          onChange={handleInputChange}
          maxLength={20}
        />
      </div>
      <div>
        <div>
          <label>Estado:</label>
        </div>
        <select
          name="estadoCasa"
          value={formData.estadoCasa}
          onChange={handleInputChange}
        >
          <option value="">- Selecione um estado -</option>
          {estadosBrasileiros.map((estado) => (
            <option key={estado.value} value={estado.value}>
              {estado.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <div>
          <label>CEP:</label>
        </div>
        <InputField
          errors={errors}
          type="text"
          name="cep"
          value={formData.cep}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <h3>CONTATOS DE CELULAR:</h3>
        <div className={styles.obsForm}>
          <p>Insira todos os seus números utilizados (pessoal e de trabalho)</p>
        </div>

        {formData.telefones.map((telefone, index) => (
          <div key={index}>
            <InputField
              errors={errors}
              type="text"
              name={`telefone-${index}`}
              value={telefone}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/\D/g, "");
                handleInputChange(
                  {
                    target: {
                      name: e.target.name,
                      value: onlyNumbers,
                    },
                  },
                  index,
                  "telefones",
                );
              }}
              maxLength={15}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder={`Telefone ${index + 1}`}
            />
          </div>
        ))}
        {formData.telefones.length < 3 && (
          <button type="button" onClick={() => addEntry("telefones")}>
            + Adicionar Telefone
          </button>
        )}
      </div>
      <div>
        <h3>E-MAILS UTILIZADOS:</h3>
        <div className={styles.obsForm}>
          <p>Insira todos os seus e-mails utilizados (pessoal e de trabalho)</p>
        </div>
        {formData.emails.map((email, index) => (
          <div key={index}>
            <InputField
              errors={errors}
              type="email"
              name={`email-${index}`}
              value={email}
              onChange={(e) => handleInputChange(e, index, "emails")}
              placeholder={`E-mail ${index + 1}`}
              style={{
                border: errors[`email-${index}`] ? "1px solid red" : undefined,
              }}
            />
            {errors[`email-${index}`] && (
              <span style={{ color: "red", fontSize: "0.8em" }}>
                {errors[`email-${index}`]}
              </span>
            )}
          </div>
        ))}

        {formData.emails.length < 3 && (
          <button type="button" onClick={() => addEntry("emails")}>
            + Adicionar E-mail
          </button>
        )}
      </div>

      <div>
        <h3>Mídias Sociais usadas nos últimos anos:</h3>

        {formData.redesSociais.map((rede, index) => {
          const prefix = SOCIAL_PREFIX[rede.plataforma] || "";
          const showUserInput =
            rede.plataforma &&
            rede.plataforma !== "SONE" &&
            rede.plataforma !== "NONE";

          return (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                width: "100%",
              }}
            >
              {/* Linha 1: Label + Select (label mínimo, select ocupa o resto) */}
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <label style={{ marginRight: 10, whiteSpace: "nowrap" }}>
                  Rede Social:
                </label>
                <select
                  style={{ flex: 1 }}
                  name={`redeSocial-${index}`}
                  value={rede.plataforma}
                  onChange={(e) => {
                    const newPlatform = e.target.value;
                    const newPrefix = SOCIAL_PREFIX[newPlatform] || "";

                    // tenta preservar o username anterior
                    let prevUser = "";
                    if (rede.usuario) {
                      const oldPrefix = SOCIAL_PREFIX[rede.plataforma] || "";
                      prevUser = (rede.usuario || "")
                        .replace(oldPrefix, "")
                        .replace(/^[@/]+/, "");
                    }

                    const finalUrl = buildSocialUrl(newPrefix, prevUser);

                    // atualiza URL final
                    handleInputChange(
                      {
                        target: {
                          name: `usuarioRede-${index}`,
                          value: finalUrl,
                        },
                      },
                      index,
                      "redesSociais",
                      "usuario",
                    );

                    // atualiza plataforma
                    handleInputChange(e, index, "redesSociais", "plataforma");
                  }}
                >
                  {socialMediaOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Linha 2: só aparece DEPOIS de selecionar uma rede; sem label, 100% de largura.
            Input group com prefixo fixo + input de username na MESMA linha e centralizados */}
              {showUserInput && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "max-content 1fr",
                      border: "1px solid #ccc",
                      borderRadius: 8,
                      overflow: "hidden",
                      height: 40,
                      boxSizing: "border-box",
                      background: "#fff",
                    }}
                  >
                    {/* Prefixo */}
                    <span
                      aria-hidden="true"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "0 12px",
                        fontFamily: "monospace",
                        fontSize: 14,
                        background: "#f6f7f9",
                        borderRight: "1px solid #e5e7eb",
                        whiteSpace: "nowrap",
                        color: "#555",
                        userSelect: "none",
                        pointerEvents: "none",
                      }}
                    >
                      {prefix || "https://"}
                    </span>

                    {/* Input */}
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        outline: "none",
                        padding: "0 12px",
                        fontSize: 14,
                        height: "100%",
                        boxSizing: "border-box",
                      }}
                      type="text"
                      name={`usuarioRedeUsername-${index}`}
                      value={extractUsernameFromFull(prefix, rede.usuario)}
                      onChange={(e) => {
                        const finalUrl = buildSocialUrl(prefix, e.target.value);
                        handleInputChange(
                          {
                            target: {
                              name: `usuarioRede-${index}`,
                              value: finalUrl,
                            },
                          },
                          index,
                          "redesSociais",
                          "usuario",
                        );
                      }}
                      placeholder="NomeDeUsuario"
                      autoComplete="off"
                    />
                  </div>
                </div>
              )}

              <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                <button
                  type="button"
                  style={{
                    padding: "5px 12px",
                    borderRadius: 20,
                    border: "1px solid #ccc",
                    background: "var(--corPrimaria)",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                  }}
                  onClick={() => {
                    const fullUrl =
                      rede.usuario ||
                      buildSocialUrl(
                        prefix,
                        extractUsernameFromFull(prefix, rede.usuario),
                      );
                    navigator.clipboard.writeText(fullUrl);
                  }}
                >
                  Copiar
                </button>

                <button
                  style={{
                    color: "red",
                    backgroundColor: "transparent",
                    padding: 5,
                    border: "1px solid red",
                    borderRadius: 20,
                  }}
                  type="button"
                  onClick={() => removeEntry("redesSociais", index)}
                >
                  - Remover
                </button>
              </div>
            </div>
          );
        })}

        <button type="button" onClick={() => addEntry("redesSociais")}>
          + Adicionar Rede Social
        </button>
      </div>
    </div>
  );
}

// Função que renderiza a etapa de Dados de Passaporte
export function DadosDePassaporte({ formData, handleInputChange, errors }) {
  return (
    <div>
      <h2>Dados de Passaporte</h2>
      <div>
        <label>Data de Emissão:</label>
        <InputField
          errors={errors}
          type="date"
          name="dataEmissaoPassaporte"
          value={formData.dataEmissaoPassaporte}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Data de Vencimento:</label>
        <InputField
          errors={errors}
          type="date"
          name="dataExpiracaoPassaporte"
          value={formData.dataExpiracaoPassaporte}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Número do Passaporte (ex: GF123456):</label>
        <InputField
          errors={errors}
          type="text"
          name="numeroPassaporte"
          value={formData.numeroPassaporte}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Em que cidade foi emitido?</label>
        <InputField
          errors={errors}
          type="text"
          name="cidadeEstadoEmissaoPassaporte"
          value={formData.cidadeEstadoEmissaoPassaporte}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Em que Estado foi emitido?</label>
        <select
          name="EstadoEmissaoPassaporte"
          value={formData.EstadoEmissaoPassaporte}
          onChange={handleInputChange}
        >
          <option value="">- Selecione um estado -</option>
          {estadosBrasileiros.map((estado) => (
            <option key={estado.value} value={estado.value}>
              {estado.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label>Você já teve algum passaporte roubado ou perdido?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="passaporteRoubadoPerdido"
            value="nao"
            checked={formData.passaporteRoubadoPerdido === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="passaporteRoubadoPerdido"
            value="sim"
            checked={formData.passaporteRoubadoPerdido === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.passaporteRoubadoPerdido === "sim" && (
          <div>
            <label>Número do Passaporte Perdido:</label>
            <InputField
              errors={errors}
              type="text"
              name="numeroPassaportePerdido"
              value={formData.numeroPassaportePerdido}
              onChange={handleInputChange}
            />
            <label>País de Emissão do Passaporte Perdido:</label>
            <InputField
              errors={errors}
              type="text"
              name="paisEmissaoPassaportePerdido"
              value={formData.paisEmissaoPassaportePerdido}
              onChange={handleInputChange}
            />
            <label>
              Explique (caso saiba, informar o número do boletim de ocorrência):
            </label>
            <textarea
              className={styles.textareaForm}
              name="detalhesPassaportePerdido"
              value={formData.detalhesPassaportePerdido}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// Função que renderiza a etapa de Informações de Família e Contatos nos EUA
export function InformacoesFamilia({
  formData,
  handleInputChange,
  errors,
  addEntry,
  removeEntry,
}) {
  return (
    <div>
      <h2>Informações de Família</h2>

      <div>
        {/* <h2>Pai:</h2> */}
        <label>Nome do Pai:</label>
        <InputField
          errors={errors}
          type="text"
          name="nomePai"
          value={formData.nomePai}
          onChange={handleInputChange}
          disabled={formData.desconheceNomePai === "sim"}
          style={{
            backgroundColor:
              formData.desconheceNomePai === "sim" ? "#a9a9a9" : "white",
          }}
        />
        <label>Sobrenome do Pai:</label>
        <InputField
          errors={errors}
          type="text"
          name="sobrenomePai"
          value={formData.sobrenomePai}
          onChange={handleInputChange}
          disabled={formData.desconheceNomePai === "sim"}
          style={{
            backgroundColor:
              formData.desconheceNomePai === "sim" ? "#a9a9a9" : "white",
          }}
        />
        <div>
          <InputField
            errors={errors}
            type="checkbox"
            style={{ width: "auto", marginRight: "5px" }}
            name="desconheceNomePai"
            checked={formData.desconheceNomePai === "sim"}
            onChange={handleInputChange}
          />
          <label>Não sei</label>
        </div>
      </div>
      <div>
        <label>Data de Nascimento do Pai:</label>
        <InputField
          errors={errors}
          type="date"
          name="dataNascimentoPai"
          value={formData.dataNascimentoPai}
          onChange={handleInputChange}
          disabled={formData.desconheceDataNascimentoPai === "sim"}
          style={{
            backgroundColor:
              formData.desconheceDataNascimentoPai === "sim"
                ? "#a9a9a9"
                : "white",
          }}
        />
        <div>
          <InputField
            errors={errors}
            type="checkbox"
            style={{ width: "auto", marginRight: "5px" }}
            name="desconheceDataNascimentoPai"
            checked={formData.desconheceDataNascimentoPai === "sim"}
            onChange={handleInputChange}
          />
          <label>Não sei</label>
        </div>
      </div>
      <div>
        <label>Nome da Mãe:</label>
        <InputField
          errors={errors}
          type="text"
          name="nomeMae"
          value={formData.nomeMae}
          onChange={handleInputChange}
          disabled={formData.desconheceNomeMae === "sim"}
          style={{
            backgroundColor:
              formData.desconheceNomeMae === "sim" ? "#a9a9a9" : "white",
          }}
        />
        <label>Sobrenome da Mãe:</label>
        <InputField
          errors={errors}
          type="text"
          name="sobrenomeMae"
          value={formData.sobrenomeMae}
          onChange={handleInputChange}
          disabled={formData.desconheceNomeMae === "sim"}
          style={{
            backgroundColor:
              formData.desconheceNomeMae === "sim" ? "#a9a9a9" : "white",
          }}
        />
        <div>
          <InputField
            errors={errors}
            type="checkbox"
            style={{ width: "auto", marginRight: "5px" }}
            name="desconheceNomeMae"
            checked={formData.desconheceNomeMae === "sim"}
            onChange={handleInputChange}
          />
          <label>Não sei</label>
        </div>
      </div>
      <div>
        <label>Data de Nascimento da Mãe:</label>
        <InputField
          errors={errors}
          type="date"
          name="dataNascimentoMae"
          value={formData.dataNascimentoMae}
          onChange={handleInputChange}
          disabled={formData.desconheceDataNascimentoMae === "sim"}
          style={{
            backgroundColor:
              formData.desconheceDataNascimentoMae === "sim"
                ? "#a9a9a9"
                : "white",
          }}
        />
      </div>
      <div>
        <InputField
          errors={errors}
          type="checkbox"
          style={{ width: "auto", marginRight: "5px" }}
          name="desconheceDataNascimentoMae"
          checked={formData.desconheceDataNascimentoMae === "sim"}
          onChange={handleInputChange}
        />
        <label>Não sei</label>
      </div>
      {/* Restante do código permanece o mesmo */}
      <div>
        <label>
          Você possui algum parente IMEDIATO nos EUA? (Pai, Mãe, Irmãos, Filhos)
        </label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="parenteImediatoEUA"
            value="nao"
            checked={formData.parenteImediatoEUA === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="parenteImediatoEUA"
            value="sim"
            checked={formData.parenteImediatoEUA === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.parenteImediatoEUA === "sim" && (
          <div>
            {formData.parentesImediatos.map((parente, index) => (
              <div key={index}>
                <label>Nome:</label>
                <InputField
                  errors={errors}
                  type="text"
                  name={`nomeParenteEUA-${index}`}
                  value={parente.nome}
                  onChange={(e) =>
                    handleInputChange(e, index, "parentesImediatos", "nome")
                  }
                />
                <label>Sobrenome:</label>
                <InputField
                  errors={errors}
                  type="text"
                  name={`sobreNomeParenteEUA-${index}`}
                  value={parente.nome}
                  onChange={(e) =>
                    handleInputChange(e, index, "parentesImediatos", "nome")
                  }
                />
                <div>
                  <label>Grau de Parentesco:</label>

                  <select
                    type="select"
                    name={`grauParentescoParenteEUA-${index}`}
                    value={parente.grauParentesco}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        index,
                        "parentesImediatos",
                        "grauParentesco",
                      )
                    }
                  >
                    <option selected="selected" value="">
                      - SELECIONE UM -
                    </option>
                    <option value="S">CÔNJUGE</option>
                    <option value="F">NOIVO/NOIVA</option>
                    <option value="C">FILHO</option>
                    <option value="B">IRMÃO</option>
                  </select>
                </div>
                <div>
                  <label>
                    Situação (cidadão americano, residente permanente legal,
                    imigrante...):
                  </label>
                  <select
                    type="select"
                    name={`situacaoParenteEUA-${index}`}
                    value={parente.situacao}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        index,
                        "parentesImediatos",
                        "situacao",
                      )
                    }
                  >
                    <option selected="selected" value="">
                      - SELECIONE UMA OPÇÃO -
                    </option>
                    <option value="S">CIDADÃO AMERICANO</option>
                    <option value="C">RESIDENTE PERMANENTE LEGAL (LPR)</option>
                    <option value="P">NÃO IMIGRANTE</option>
                    <option value="O">OUTRO/NÃO SEI</option>
                  </select>
                </div>
                <button
                  style={{
                    color: " red",
                    backgroundColor: "#ffffff00",
                    marginBottom: "20px",
                    padding: "5px",
                    border: "solid 1px  red",
                    borderRadius: "20px",
                  }}
                  type="button"
                  onClick={() => removeEntry("parentesImediatos", index)}
                >
                  - Remover
                </button>
              </div>
            ))}
            {formData.parentesImediatos.length < 10 && (
              <button
                type="button"
                onClick={() => addEntry("parentesImediatos")}
              >
                + Adicionar Parente
              </button>
            )}
          </div>
        )}
      </div>
      <div>
        <label>
          Você possui algum parente nos EUA? (Tios, Primos, parentes distantes)
        </label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="parenteEUA"
            value="nao"
            checked={formData.parenteEUA === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="parenteEUA"
            value="sim"
            checked={formData.parenteEUA === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
      </div>
      <h2>Informações de Contatos nos EUA</h2>
      <div>
        <label>
          Você possui algum contato com os EUA? (Parentes, amigos, escolas,
          contatos comerciais)
        </label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="contatoEUA"
            value="nao"
            checked={formData.contatoEUA === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="contatoEUA"
            value="sim"
            checked={formData.contatoEUA === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.contatoEUA === "sim" && (
          <div>
            <h3>Informações do Contato nos EUA</h3>

            <label>Nome:</label>
            <InputField
              errors={errors}
              type="text"
              name="nomeContatoEUA"
              value={formData.nomeContatoEUA}
              onChange={handleInputChange}
            />
            <label>Sobrenome:</label>

            <InputField
              errors={errors}
              type="text"
              name="sobreNomeContatoEUA"
              value={formData.sobreNomeContatoEUA}
              onChange={handleInputChange}
            />

            <label>Relação/Parentesco:</label>

            <select
              type="select"
              name="relacaoContatoEUA"
              value={formData.relacaoContatoEUA}
              onChange={handleInputChange}
            >
              <option value="">- SELECIONE UMA OPÇÃO -</option>
              <option value="R">PAI / MÃE</option>
              <option value="S">CÔNJUGE</option>
              <option value="C">AMIGO</option>
              <option value="B">ASSOCIADO DE NEGÓCIOS</option>
              <option value="P">EMPREGADOR</option>
              <option value="H">FUNCIONÁRIO DA ESCOLA</option>
              <option value="F">FILHO / PARENTE</option>

              <option selected="selected" value="O">
                OUTRO
              </option>
            </select>

            <h4>Endereço nos EUA</h4>
            <label>Endereço:</label>
            <InputField
              errors={errors}
              type="text"
              name="enderecoContatoEUA"
              value={formData.enderecoContatoEUA}
              onChange={handleInputChange}
            />
            <label>Bairro:</label>
            <InputField
              errors={errors}
              type="text"
              name="bairroContatoEUA"
              value={formData.bairroContatoEUA}
              onChange={handleInputChange}
            />
            <label>Cidade:</label>
            <InputField
              errors={errors}
              type="text"
              name="cidadeContatoEUA"
              value={formData.cidadeContatoEUA}
              onChange={handleInputChange}
            />
            <div>
              <div>
                <label>Estado:</label>
              </div>
            </div>
            <select
              name="estadoContatoEUA"
              value={formData.estadoContatoEUA}
              onChange={handleInputChange}
            >
              <option value="">- Selecione um estado -</option>
              {estados.map((estado) => (
                <option key={estado.value} value={estado.value}>
                  {estado.label}
                </option>
              ))}
            </select>
            <div>
              <label>CEP:</label>
            </div>
            <InputField
              errors={errors}
              type="text"
              name="cepContatoEUA"
              value={formData.cepContatoEUA}
              onChange={handleInputChange}
            />
            <label>Telefone:</label>
            <InputField
              errors={errors}
              type="text"
              name="telefoneContatoEUA"
              value={formData.telefoneContatoEUA}
              onChange={(e) => sanitizeNumberInput(e, handleInputChange)}
              maxLength={15}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="Digite apenas números"
            />

            <div>
              <label>E-mail:</label>
            </div>
            <InputField
              errors={errors}
              type="email"
              name="emailContatoEUA"
              value={formData.emailContatoEUA}
              onChange={handleInputChange}
              style={{
                border: errors.emailContatoEUA ? "1px solid red" : undefined,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// Componente para a seção de Informações Adicionais
export function InformacoesAdicionais({
  formData,
  handleInputChange,
  addEntry,
  removeEntry,
  setFormField,
  errors,
}) {
  return (
    <div>
      <h2>Informações Adicionais</h2>
      {/* Idiomas */}
      <div>
        <label>
          Você fala algum outro idioma, além do português? Em qual idioma voce
          gostria de fazer entrevista?{" "}
        </label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="idiomas"
            value="nao"
            checked={formData.idiomasFalados.length === 0}
            onChange={() => setFormField("idiomasFalados", [])}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="idiomas"
            value="sim"
            checked={formData.idiomasFalados.length > 0}
            onChange={() => addEntry("idiomasFalados")}
          />
          <label>Sim</label>
        </div>
        {formData.idiomasFalados.length > 0 && (
          <div>
            {formData.idiomasFalados.map((idioma, index) => (
              <div key={index}>
                <InputField
                  errors={errors}
                  type="text"
                  name={`idioma-${index}`}
                  value={idioma}
                  onChange={(e) =>
                    handleInputChange(e, index, "idiomasFalados")
                  }
                  placeholder={`Idioma ${index + 1}`}
                />
                <button
                  style={{
                    color: " red",
                    backgroundColor: "#ffffff00",
                    marginBottom: "20px",
                    padding: "5px",
                    border: "solid 1px  red",
                    borderRadius: "20px",
                  }}
                  type="button"
                  onClick={() => removeEntry("idiomasFalados", index)}
                >
                  - Remover
                </button>
              </div>
            ))}
            <button type="button" onClick={() => addEntry("idiomasFalados")}>
              + Adicionar Idioma
            </button>
          </div>
        )}
      </div>
      {/* Viagens Recentes */}
      <div>
        <label>Você viajou para outros países nos últimos 05 anos?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="viagensRecentes"
            value="nao"
            checked={formData.viagensRecentes.length === 0}
            onChange={() => setFormField("viagensRecentes", [])}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="viagensRecentes"
            value="sim"
            checked={formData.viagensRecentes.length > 0}
            onChange={() => addEntry("viagensRecentes")}
          />
          <label>Sim</label>
        </div>
        {formData.viagensRecentes.length > 0 && (
          <div>
            {formData.viagensRecentes.map((pais, index) => (
              <div key={index}>
                <select
                  name={`pais-${index}`}
                  value={pais}
                  onChange={(e) =>
                    handleInputChange(e, index, "viagensRecentes")
                  }
                  style={{ marginRight: "10px" }}
                >
                  {paisesMundo.map((option) => {
                    // Verifica se o option já foi selecionado em outro "select"
                    const jaSelecionado =
                      formData.viagensRecentes.includes(option.value) &&
                      option.value !== pais; // exceto no próprio select atual

                    return (
                      <option
                        key={option.value}
                        value={option.value}
                        disabled={jaSelecionado}
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </select>

                <button
                  style={{
                    color: " red",
                    backgroundColor: "#ffffff00",
                    marginBottom: "20px",
                    padding: "5px",
                    border: "solid 1px  red",
                    borderRadius: "20px",
                  }}
                  type="button"
                  onClick={() => removeEntry("viagensRecentes", index)}
                >
                  - Remover
                </button>
              </div>
            ))}
            <button type="button" onClick={() => addEntry("viagensRecentes")}>
              + Adicionar País
            </button>
          </div>
        )}
      </div>
      {/* Organizações Sociais ou de Caridade */}
      <div>
        <label>Participa de Organizações Sociais ou de Caridade?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="participaOrganizacoes"
            value="nao"
            checked={formData.participaOrganizacoes === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="participaOrganizacoes"
            value="sim"
            checked={formData.participaOrganizacoes === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.participaOrganizacoes === "sim" && (
          <div>
            {formData.organizacoes && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {formData.organizacoes.length} / 66
              </span>
            )}
            <textarea
              className={styles.textareaForm}
              name="organizacoes"
              value={formData.organizacoes}
              onChange={handleInputChange}
              placeholder="Explique sua participação em organizações sociais"
              maxLength={66}
            />
          </div>
        )}
      </div>
      {/* Risco a sim mesmo ou a outro */}
      <div>
        <label>
          Você tem algum transtorno mental ou físico que pode representar uma
          ameaça à sua segurança ou bem-estar ou ao de outras pessoas?
        </label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="temdoenca"
            value="nao"
            checked={formData.temdoenca === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="temdoenca"
            value="sim"
            checked={formData.temdoenca === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.temdoenca === "sim" && (
          <div>
            <InputField
              errors={errors}
              type="text"
              name="doenca"
              value={formData.doenca}
              onChange={handleInputChange}
              placeholder="Explique sua condição"
            />
          </div>
        )}
      </div>

      {/* Habilidades em Armas ou Química */}
      <div>
        <label>Possui Habilidades em Armas de fogo ou Química?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="temHabilidadesEspeciais"
            value="nao"
            checked={formData.temHabilidadesEspeciais === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="temHabilidadesEspeciais"
            value="sim"
            checked={formData.temHabilidadesEspeciais === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.temHabilidadesEspeciais === "sim" && (
          <div>
            {formData.habilidadesEspeciais && (
              <span
                style={{
                  fontSize: "0.9em",
                  color: "#555",
                  paddingLeft: "10px",
                }}
              >
                {formData.habilidadesEspeciais.length} / 4000
              </span>
            )}
            <InputField
              errors={errors}
              type="text"
              name="habilidadesEspeciais"
              value={formData.habilidadesEspeciais}
              onChange={handleInputChange}
              placeholder="Explique suas habilidades especiais"
              maxLength={4000}
            />
          </div>
        )}
      </div>
      {/* Condenações Judiciais */}
      <div>
        <label>Possui Condenações Judiciais?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="temCondenacoes"
            value="nao"
            checked={formData.temCondenacoes === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="temCondenacoes"
            value="sim"
            checked={formData.temCondenacoes === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.temCondenacoes === "sim" && (
          <div>
            <textarea
              className={styles.textareaForm}
              name="condenacoes"
              value={formData.condenacoes}
              onChange={handleInputChange}
              placeholder="Explique suas condenações judiciais"
            />
          </div>
        )}
      </div>
      {/* Serviço Militar */}
      <div>
        <label>Você prestou serviço militar?</label>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="prestouMilitar"
            value="nao"
            checked={formData.prestouMilitar === "nao"}
            onChange={handleInputChange}
          />
          <label>Não</label>
        </div>
        <div>
          <InputField
            errors={errors}
            style={{ width: "auto" }}
            type="radio"
            name="prestouMilitar"
            value="sim"
            checked={formData.prestouMilitar === "sim"}
            onChange={handleInputChange}
          />
          <label>Sim</label>
        </div>
        {formData.prestouMilitar === "sim" && (
          <div>
            <h3>Detalhes do Serviço Militar:</h3>
            <label>País onde prestou o serviço militar:</label>
            <InputField
              errors={errors}
              type="text"
              name="servicoMilitarPais"
              value={formData.servicoMilitarPais}
              onChange={handleInputChange}
            />
            <label>Nome do batalhão/tipo de serviço:</label>
            <InputField
              errors={errors}
              type="text"
              name="servicoMilitarBatalhao"
              value={formData.servicoMilitarBatalhao}
              onChange={handleInputChange}
            />
            <label>Posição/patente:</label>
            <InputField
              errors={errors}
              type="text"
              name="servicoMilitarPosicao"
              value={formData.servicoMilitarPosicao}
              onChange={handleInputChange}
            />
            <label>Especialidade militar:</label>
            <InputField
              errors={errors}
              type="text"
              name="servicoMilitarEspecialidade"
              value={formData.servicoMilitarEspecialidade}
              onChange={handleInputChange}
            />
            <label>Data de início do serviço:</label>
            <InputField
              errors={errors}
              type="date"
              name="servicoMilitarDataInicio"
              value={formData.servicoMilitarDataInicio}
              onChange={handleInputChange}
            />
            <label>Data do término do serviço:</label>
            <InputField
              errors={errors}
              type="date"
              name="servicoMilitarDataTermino"
              value={formData.servicoMilitarDataTermino}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}
